import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type RequireFields<T, K extends keyof T> = { [X in Exclude<keyof T, K>]?: T[X] } & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Upload: any;
};


export type Query = {
  __typename?: 'Query';
  _?: Maybe<Scalars['String']>;
  health: Scalars['Boolean'];
  uploadPage: UploadPage;
  post?: Maybe<Post>;
  postPage: PostPage;
  likedPostPage?: Maybe<LikedPostPage>;
  mapTokensToPostPage?: Maybe<MappedPostPage>;
  me?: Maybe<User>;
  user?: Maybe<User>;
  userPage: UserPage;
  userAccountName: AccountName;
  isTestUser: Scalars['Boolean'];
  tags?: Maybe<Array<Maybe<Tag>>>;
  tag?: Maybe<Tag>;
  subscriptionPlan?: Maybe<SubscriptionPlan>;
  subscriptionPlanPage?: Maybe<SubscriptionPlanPage>;
  like?: Maybe<Like>;
  userSubscriptionPage: UserSubscriptionPage;
  subscriberPage: UserSubscriptionPage;
  subscriberPageForCms: UserSubscriptionPage;
  followUserPage: FollowUserPage;
  followUserDoc?: Maybe<FollowUser>;
  followTagPage: FollowTagPage;
  followTagDoc?: Maybe<FollowTag>;
  channels?: Maybe<Array<Maybe<Channel>>>;
  channel?: Maybe<Channel>;
  hasNotification?: Maybe<Scalars['Boolean']>;
  notificationPage: NotificationPage;
  commentPage?: Maybe<CommentPage>;
  followChannelPage: FollowChannelPage;
  /** @deprecated Replaced by followChannelPage */
  followerChannelPage: FollowChannelPage;
  followChannelDoc?: Maybe<FollowChannel>;
  chatPage?: Maybe<ChatPage>;
  initialChat?: Maybe<InitialChat>;
  hasMessage?: Maybe<Scalars['Boolean']>;
  messagePage?: Maybe<MessagePage>;
  userPaymentMethods: Array<Maybe<UserPaymentMethod>>;
  userInvoicePage: UserInvoicePage;
  topPosts: Array<TopPost>;
  topTags: Array<TopTag>;
  topWriters: Array<TopWriter>;
  userReceivePaymentMethods: Array<Maybe<UserReceivePaymentMethod>>;
  enabledPayoutProviders: Array<Maybe<ReceivePaymentMethodProviderEnum>>;
  userPayoutPage: UserPayoutPage;
  userWallet?: Maybe<UserWallet>;
  enabledFeatures?: Maybe<Array<Maybe<FeatureNameEnum>>>;
  application?: Maybe<Application>;
};


export type QueryUploadPageArgs = {
  input: SearchInput;
};


export type QueryPostArgs = {
  slug: Scalars['String'];
  isOriginalImage?: Maybe<Scalars['Boolean']>;
};


export type QueryPostPageArgs = {
  input?: Maybe<PostPageInput>;
  paging?: Maybe<CursorPagingInput>;
};


export type QueryLikedPostPageArgs = {
  postTypes: Array<Maybe<PostTypeEnum>>;
  paging?: Maybe<CursorPagingInput>;
};


export type QueryMapTokensToPostPageArgs = {
  purchasedOnly: Scalars['Boolean'];
  showSensitiveContent?: Maybe<Scalars['Boolean']>;
  userId: Scalars['String'];
  tokenIds: Array<Maybe<Scalars['String']>>;
  nextOffset: Scalars['String'];
  hasNext: Scalars['Boolean'];
};


export type QueryUserArgs = {
  accountName?: Maybe<Scalars['String']>;
  walletAccount?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};


export type QueryUserPageArgs = {
  input?: Maybe<SearchInput>;
};


export type QueryUserAccountNameArgs = {
  accountName: Scalars['String'];
};


export type QueryIsTestUserArgs = {
  email: Scalars['String'];
};


export type QueryTagsArgs = {
  limit?: Maybe<Scalars['Int']>;
};


export type QueryTagArgs = {
  value: Scalars['String'];
};


export type QuerySubscriptionPlanArgs = {
  slug: Scalars['String'];
};


export type QuerySubscriptionPlanPageArgs = {
  input?: Maybe<SearchInput>;
};


export type QueryLikeArgs = {
  postId: Scalars['String'];
};


export type QueryUserSubscriptionPageArgs = {
  input: UserSubscriptionPageInput;
  paging?: Maybe<CursorPagingInput>;
};


export type QuerySubscriberPageArgs = {
  input: SubscriberPageInput;
  paging?: Maybe<CursorPagingInput>;
};


export type QuerySubscriberPageForCmsArgs = {
  input?: Maybe<SubscriberPageForCmsInput>;
  paging?: Maybe<CursorPagingInput>;
};


export type QueryFollowUserPageArgs = {
  userId?: Maybe<Scalars['String']>;
  writerId?: Maybe<Scalars['String']>;
  paging?: Maybe<CursorPagingInput>;
};


export type QueryFollowUserDocArgs = {
  writerId: Scalars['ID'];
};


export type QueryFollowTagPageArgs = {
  input?: Maybe<SearchInput>;
};


export type QueryFollowTagDocArgs = {
  tagId: Scalars['ID'];
};


export type QueryChannelsArgs = {
  userId?: Maybe<Scalars['String']>;
  channelStatus?: Maybe<Array<ChannelStatusEnum>>;
};


export type QueryChannelArgs = {
  slug: Scalars['String'];
};


export type QueryNotificationPageArgs = {
  paging?: Maybe<CursorPagingInput>;
};


export type QueryCommentPageArgs = {
  input: CommentPageInput;
  paging?: Maybe<CursorPagingInput>;
};


export type QueryFollowChannelPageArgs = {
  input: FollowChannelQueryInput;
  paging?: Maybe<CursorPagingInput>;
};


export type QueryFollowerChannelPageArgs = {
  input: SearchInput;
  paging?: Maybe<CursorPagingInput>;
  creatorId: Scalars['String'];
};


export type QueryFollowChannelDocArgs = {
  channelId: Scalars['ID'];
};


export type QueryChatPageArgs = {
  paging?: Maybe<CursorPagingInput>;
};


export type QueryInitialChatArgs = {
  input: UserInput;
};


export type QueryMessagePageArgs = {
  input: SearchInput;
  currentUserId: Scalars['String'];
  relatedUserId: Scalars['String'];
  paging?: Maybe<CursorPagingInput>;
};


export type QueryUserPaymentMethodsArgs = {
  userId: Scalars['String'];
  paymentMethodStatus: Array<PaymentMethodStatusEnum>;
  paymentMethodProvider?: Maybe<PaymentMethodProviderEnum>;
};


export type QueryUserInvoicePageArgs = {
  userId: Scalars['String'];
  paging?: Maybe<CursorPagingInput>;
};


export type QueryUserReceivePaymentMethodsArgs = {
  userId: Scalars['String'];
};


export type QueryUserPayoutPageArgs = {
  userId: Scalars['String'];
  paging?: Maybe<CursorPagingInput>;
};


export type QueryUserWalletArgs = {
  startAt?: Maybe<Scalars['String']>;
  currency?: Maybe<CurrencyEnum>;
};


export type QueryApplicationArgs = {
  type: ApplicationTypeEnum;
};

export type Mutation = {
  __typename?: 'Mutation';
  _?: Maybe<Scalars['String']>;
  uploadFiles?: Maybe<Array<Maybe<CustomUpload>>>;
  reportPost: Scalars['Boolean'];
  createPost: Post;
  updatePost?: Maybe<Post>;
  publishPost?: Maybe<Post>;
  removePost?: Maybe<Post>;
  updateUser: User;
  udpateUserNotificationLastSeen: User;
  udpateUserMessageLastSeen: User;
  linkWalletAccount: User;
  updateUserCreatorTier: User;
  createTag?: Maybe<Tag>;
  createSubscriptionPlan: SubscriptionPlan;
  updateSubscriptionPlan?: Maybe<SubscriptionPlan>;
  removeSubscriptionPlan?: Maybe<SubscriptionPlan>;
  createLike?: Maybe<Like>;
  removeLike?: Maybe<Like>;
  purchaseExpiredContentWithStripe: StripePaymentResponse;
  subscribeWithStripe?: Maybe<StripePaymentResponse>;
  /** deprecated */
  createUserSubscriptionPlanWithExistingPaymentMethod: CreateUserSubscriptionPlanResponse;
  /** deprecated */
  createUserSubscriptionPlanWithNewPaymentMethod: CreateUserSubscriptionPlanResponse;
  cancelUserSubscriptionPlan: UserSubscriptionPlan;
  reactivateSubscription: UserSubscriptionPlan;
  followUser: FollowUser;
  unfollowUser: FollowUser;
  followTag: FollowTag;
  unfollowTag: FollowTag;
  createChannel: Channel;
  updateChannel: UpdateChannelResponse;
  removeChannel: Channel;
  updateNotificationStatus: Notification;
  confirmNftPurchase?: Maybe<NftNotificationResponse>;
  confirmNftList?: Maybe<NftNotificationResponse>;
  confirmNftCancelList?: Maybe<NftNotificationResponse>;
  confirmNftUpdateList?: Maybe<NftNotificationResponse>;
  createComment: Comment;
  removeComment: Comment;
  followChannel: FollowChannel;
  unfollowChannel: FollowChannel;
  createMessage: Message;
  updateMessage: Message;
  removeMessage: Message;
  readMessages: Array<Maybe<Message>>;
  removeUserPaymentMethod: UserPaymentMethod;
  addUserPaymentMethodStripe: UserPaymentMethod;
  createUserReceivePaymentMethod: UserReceivePaymentMethod;
  updateUserReceivePaymentMethod: UserReceivePaymentMethod;
  updateAutoTransfer: UserReceivePaymentMethod;
  createUserPayout: UserPayout;
  createApplication: SubmittedApplicationResponse;
  updateApplication: SubmittedApplicationResponse;
};


export type MutationUploadFilesArgs = {
  input?: Maybe<UploadFileInput>;
};


export type MutationReportPostArgs = {
  input: ReportPostInput;
};


export type MutationCreatePostArgs = {
  postType?: Maybe<PostTypeEnum>;
  isOriginalImage?: Maybe<Scalars['Boolean']>;
};


export type MutationUpdatePostArgs = {
  input: UpdatePostInput;
};


export type MutationPublishPostArgs = {
  slug: Scalars['String'];
};


export type MutationRemovePostArgs = {
  slug: Scalars['String'];
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationLinkWalletAccountArgs = {
  walletAccount: Scalars['String'];
};


export type MutationCreateTagArgs = {
  input: TagInput;
};


export type MutationCreateSubscriptionPlanArgs = {
  input: CreateSubscriptionPlanInput;
};


export type MutationUpdateSubscriptionPlanArgs = {
  input: UpdateSubscriptionPlanInput;
};


export type MutationRemoveSubscriptionPlanArgs = {
  _id: Scalars['String'];
  removeAllPosts?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateLikeArgs = {
  postId: Scalars['String'];
};


export type MutationRemoveLikeArgs = {
  postId: Scalars['String'];
};


export type MutationPurchaseExpiredContentWithStripeArgs = {
  subscriptionPlanId: Scalars['String'];
  postId: Scalars['String'];
  userPaymentMethodId?: Maybe<Scalars['String']>;
  paymentMethodId?: Maybe<Scalars['String']>;
  paymentMethodProvider?: Maybe<PaymentMethodProviderEnum>;
  email?: Maybe<Scalars['String']>;
};


export type MutationSubscribeWithStripeArgs = {
  subscriptionPlanId: Scalars['String'];
  userPaymentMethodId?: Maybe<Scalars['String']>;
  paymentMethodId?: Maybe<Scalars['String']>;
  paymentMethodProvider?: Maybe<PaymentMethodProviderEnum>;
  email?: Maybe<Scalars['String']>;
};


export type MutationCreateUserSubscriptionPlanWithExistingPaymentMethodArgs = {
  subscriptionPlanId: Scalars['String'];
  userPaymentMethodId: Scalars['String'];
};


export type MutationCreateUserSubscriptionPlanWithNewPaymentMethodArgs = {
  subscriptionPlanId: Scalars['String'];
  paymentMethodId: Scalars['String'];
};


export type MutationCancelUserSubscriptionPlanArgs = {
  userSubscriptionPlanId: Scalars['String'];
};


export type MutationReactivateSubscriptionArgs = {
  userSubscriptionPlanId: Scalars['String'];
};


export type MutationFollowUserArgs = {
  writerId: Scalars['ID'];
};


export type MutationUnfollowUserArgs = {
  writerId: Scalars['ID'];
};


export type MutationFollowTagArgs = {
  tagId: Scalars['ID'];
};


export type MutationUnfollowTagArgs = {
  tagId: Scalars['ID'];
};


export type MutationCreateChannelArgs = {
  title: Scalars['String'];
  isSensitive: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  isCommentRestricted?: Maybe<Scalars['Boolean']>;
};


export type MutationUpdateChannelArgs = {
  input: UpdateChannelInput;
};


export type MutationRemoveChannelArgs = {
  _id: Scalars['String'];
};


export type MutationUpdateNotificationStatusArgs = {
  input: UpdateNotificationInput;
};


export type MutationConfirmNftPurchaseArgs = {
  transactionHash: Scalars['String'];
};


export type MutationConfirmNftListArgs = {
  transactionHash: Scalars['String'];
};


export type MutationConfirmNftCancelListArgs = {
  transactionHash: Scalars['String'];
};


export type MutationConfirmNftUpdateListArgs = {
  transactionHash: Scalars['String'];
};


export type MutationCreateCommentArgs = {
  input: CreateCommentInput;
};


export type MutationRemoveCommentArgs = {
  commentId: Scalars['String'];
};


export type MutationFollowChannelArgs = {
  channelId: Scalars['ID'];
};


export type MutationUnfollowChannelArgs = {
  channelId: Scalars['ID'];
};


export type MutationCreateMessageArgs = {
  input: CreateMessageInput;
};


export type MutationUpdateMessageArgs = {
  input: UpdateMessageInput;
};


export type MutationRemoveMessageArgs = {
  _id: Scalars['String'];
};


export type MutationReadMessagesArgs = {
  senderId: Scalars['String'];
};


export type MutationRemoveUserPaymentMethodArgs = {
  _id: Scalars['String'];
};


export type MutationAddUserPaymentMethodStripeArgs = {
  email?: Maybe<Scalars['String']>;
  paymentMethodId: Scalars['String'];
  paymentMethodProvider?: Maybe<PaymentMethodProviderEnum>;
};


export type MutationCreateUserReceivePaymentMethodArgs = {
  input: CreateUserReceivePaymentMethodInput;
};


export type MutationUpdateUserReceivePaymentMethodArgs = {
  input: UpdateUserReceivePaymentMethodInput;
};


export type MutationUpdateAutoTransferArgs = {
  receivePaymentMethodId: Scalars['String'];
  autoTransfer: Scalars['Boolean'];
};


export type MutationCreateUserPayoutArgs = {
  input: CreateUserPayoutInput;
};


export type MutationCreateApplicationArgs = {
  input: CreateApplicationInput;
};


export type MutationUpdateApplicationArgs = {
  input: UpdateApplicationInput;
};

export type IntCriterionInput = {
  eq?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Maybe<Scalars['Int']>>>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  not?: Maybe<Scalars['Boolean']>;
  exists?: Maybe<Scalars['Boolean']>;
};

export type StringCriterionInput = {
  eq?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Maybe<Scalars['String']>>>;
  like?: Maybe<Scalars['String']>;
  not?: Maybe<Scalars['Boolean']>;
  regex?: Maybe<Scalars['String']>;
  exists?: Maybe<Scalars['Boolean']>;
};

export type TimeCriterionInput = {
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  not?: Maybe<Scalars['Boolean']>;
  exists?: Maybe<Scalars['Boolean']>;
};

export type SearchCriteriaInput = {
  field?: Maybe<Scalars['String']>;
  orSearchCriteria?: Maybe<Array<SearchCriteriaInput>>;
  intCriterion?: Maybe<IntCriterionInput>;
  stringCriterion?: Maybe<StringCriterionInput>;
  timeCriterion?: Maybe<TimeCriterionInput>;
};

export enum SorterTypeEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SorterInput = {
  field: Scalars['String'];
  type: SorterTypeEnum;
};

export type PagingInput = {
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  pageToken?: Maybe<Scalars['Int']>;
};

export type SearchInput = {
  searchCriteria?: Maybe<Array<SearchCriteriaInput>>;
  sorter?: Maybe<Array<SorterInput>>;
  paging?: Maybe<PagingInput>;
};

export type CursorSortingInput = {
  sortBy?: Maybe<Scalars['String']>;
  isAscending?: Maybe<Scalars['Boolean']>;
};

export type CursorPagingInput = {
  limit?: Maybe<Scalars['Int']>;
  next?: Maybe<Scalars['String']>;
};

export type CursorPagingInfo = {
  __typename?: 'CursorPagingInfo';
  previous?: Maybe<Scalars['String']>;
  next?: Maybe<Scalars['String']>;
  hasNext: Scalars['Boolean'];
};

export type File = {
  __typename?: 'File';
  filename: Scalars['String'];
  mimetype: Scalars['String'];
  encoding: Scalars['String'];
};

export type IntrinsicSize = {
  __typename?: 'IntrinsicSize';
  height: Scalars['Int'];
  width: Scalars['Int'];
};

export type CustomUpload = {
  __typename?: 'CustomUpload';
  _id?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  filepath?: Maybe<Scalars['String']>;
  fileType?: Maybe<FileTypeEnum>;
  uploadType?: Maybe<UploadTypeEnum>;
  uploadStatus?: Maybe<UploadStatusEnum>;
  writerId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type UploadShort = {
  __typename?: 'UploadShort';
  _id: Scalars['ID'];
  url: Scalars['String'];
  uploadType: UploadTypeEnum;
  fileType: FileTypeEnum;
  filepath?: Maybe<Scalars['String']>;
  hasAlpha?: Maybe<Scalars['Boolean']>;
  intrinsicSize?: Maybe<IntrinsicSize>;
};

export type UploadPage = {
  __typename?: 'UploadPage';
  items: Array<Maybe<CustomUpload>>;
  count?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  pageToken?: Maybe<Scalars['Int']>;
};

export enum UploadTypeEnum {
  Firebase = 'FIREBASE',
  Cloudinary = 'CLOUDINARY',
  ExternalLink = 'EXTERNAL_LINK',
  Local = 'LOCAL'
}

export enum FileUsageEnum {
  Profile = 'PROFILE',
  Post = 'POST',
  PostArticle = 'POST_ARTICLE',
  SubscriptionPlan = 'SUBSCRIPTION_PLAN',
  Chat = 'CHAT',
  Application = 'APPLICATION'
}

export enum CmsFileUsageEnum {
  PayoutReceipt = 'PAYOUT_RECEIPT'
}

export enum FileTypeEnum {
  Image = 'IMAGE',
  Video = 'VIDEO',
  Audio = 'AUDIO',
  Other = 'OTHER'
}

export enum UploadStatusEnum {
  Saved = 'SAVED',
  Active = 'ACTIVE',
  Removed = 'REMOVED'
}

export type UploadFileInput = {
  files?: Maybe<Array<Maybe<Scalars['Upload']>>>;
  postId?: Maybe<Scalars['String']>;
  fileUsage: FileUsageEnum;
};

export type IntrinsicSizeInput = {
  height: Scalars['Int'];
  width: Scalars['Int'];
};

export type UploadInput = {
  _id: Scalars['ID'];
  uploadType: UploadTypeEnum;
  url: Scalars['String'];
  fileType: FileTypeEnum;
  filepath?: Maybe<Scalars['String']>;
  hasAlpha?: Maybe<Scalars['Boolean']>;
  intrinsicSize?: Maybe<IntrinsicSizeInput>;
};

export type Post = {
  __typename?: 'Post';
  _id: Scalars['ID'];
  id: Scalars['String'];
  slug: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  views: Scalars['Int'];
  likes: Scalars['Int'];
  /** @deprecated This field has been seperated into userBlurLevel and postBlurLevel */
  blur?: Maybe<Scalars['Int']>;
  userBlurLevel?: Maybe<Scalars['Int']>;
  /** @deprecated This field has been replaced by isUserContentLocked */
  userVisibleHeight?: Maybe<Scalars['Int']>;
  postBlurLevel?: Maybe<Scalars['Int']>;
  /** @deprecated This field has been replaced by isContentLocked */
  visibleHeight?: Maybe<Scalars['Int']>;
  postStatus: PostStatusEnum;
  writer: User;
  writerId: Scalars['String'];
  subscriptionPlanId?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<UploadShort>>>;
  content?: Maybe<RichTextContent>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  previewImage?: Maybe<UploadShort>;
  createdAt: Scalars['String'];
  updatedAt: Scalars['String'];
  multipleImages: Scalars['Boolean'];
  channelId?: Maybe<Scalars['String']>;
  isSensitive: Scalars['Boolean'];
  channel?: Maybe<Channel>;
  commentCount: Scalars['Int'];
  watermarkPosition?: Maybe<WatermarkPositionEnum>;
  hasCurrentUserReport: Scalars['Boolean'];
  hasCurrentUserLike: Scalars['Boolean'];
  ownerBlurImageUrl?: Maybe<Scalars['String']>;
  tokenId?: Maybe<Scalars['String']>;
  postType: PostTypeEnum;
  previewContent?: Maybe<Scalars['String']>;
  isContentLocked?: Maybe<Scalars['Boolean']>;
  isUserContentLocked: Scalars['Boolean'];
  subscriptionPlan?: Maybe<SubscriptionPlan>;
  price?: Maybe<Scalars['Float']>;
  currency?: Maybe<CurrencyEnum>;
  cid?: Maybe<Scalars['String']>;
  asset?: Maybe<NftInfo>;
  videoUri?: Maybe<Scalars['String']>;
  publishAt?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
};


export type PostImagesArgs = {
  signedUrlCount?: Maybe<Scalars['Int']>;
  isOriginalImage?: Maybe<Scalars['Boolean']>;
};

export type LikedPost = {
  __typename?: 'LikedPost';
  _id: Scalars['ID'];
  postId: Scalars['String'];
  userId: Scalars['String'];
  post: Post;
};

export type PostPage = {
  __typename?: 'PostPage';
  items: Array<Maybe<Post>>;
  paging: CursorPagingInfo;
};

export type LikedPostPage = {
  __typename?: 'LikedPostPage';
  items: Array<Maybe<LikedPost>>;
  paging: CursorPagingInfo;
};

export type MappedPostPage = {
  __typename?: 'MappedPostPage';
  items: Array<Maybe<Post>>;
  paging: CursorPagingInfo;
};

export type NftInfo = {
  __typename?: 'NftInfo';
  id: Scalars['String'];
  owner: Scalars['String'];
  initialOwner: Scalars['String'];
  price: Scalars['String'];
  listStatus: Scalars['Boolean'];
  cid?: Maybe<Scalars['String']>;
};

export enum PostStatusEnum {
  Published = 'PUBLISHED',
  Removed = 'REMOVED',
  Drafted = 'DRAFTED',
  Banned = 'BANNED'
}

export enum WatermarkPositionEnum {
  Clear = 'CLEAR',
  BottomLeft = 'BOTTOM_LEFT',
  BottomRight = 'BOTTOM_RIGHT'
}

export enum PostReportStatusEnum {
  Processing = 'PROCESSING',
  Reviewed = 'REVIEWED'
}

export enum PostTypeEnum {
  Article = 'ARTICLE',
  Normal = 'NORMAL',
  Nft = 'NFT',
  Eth721 = 'ETH721',
  Video = 'VIDEO'
}

export type UpdatePostInput = {
  _id?: Maybe<Scalars['ID']>;
  slug: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  channelId: Scalars['String'];
  postBlurLevel?: Maybe<Scalars['Int']>;
  visibleHeight?: Maybe<Scalars['Int']>;
  postStatus: PostStatusEnum;
  content?: Maybe<UpdateRichTextInput>;
  tags?: Maybe<Array<Maybe<TagInput>>>;
  images?: Maybe<Array<Maybe<UploadInput>>>;
  watermarkPosition?: Maybe<WatermarkPositionEnum>;
  subscriptionPlanId?: Maybe<Scalars['String']>;
  tokenId?: Maybe<Scalars['String']>;
  postType?: Maybe<PostTypeEnum>;
  previewContent?: Maybe<Scalars['String']>;
  videoUri?: Maybe<Scalars['String']>;
  publishAt?: Maybe<Scalars['String']>;
};

export type ReportPostInput = {
  postId: Scalars['String'];
  reporterId: Scalars['String'];
  content: Scalars['String'];
  writerId: Scalars['String'];
};

export type PostPageInput = {
  tagValue?: Maybe<Scalars['String']>;
  writerId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  latest?: Maybe<Scalars['Boolean']>;
  isOwner?: Maybe<Scalars['Boolean']>;
  showSensitiveContent?: Maybe<Scalars['Boolean']>;
  showPaidContent?: Maybe<Scalars['Boolean']>;
  postTypes?: Maybe<Array<Maybe<PostTypeEnum>>>;
};

export type BlurPostCount = {
  __typename?: 'BlurPostCount';
  currentMonth?: Maybe<Scalars['Int']>;
  lastMonth?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type AccountName = {
  __typename?: 'AccountName';
  validationStatus: AccountNameValidationStatusEnum;
  suggestions?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CreatorType = {
  __typename?: 'CreatorType';
  tier: CreatorTypeEnum;
  updatedAt: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  _id: Scalars['ID'];
  email?: Maybe<Scalars['String']>;
  loginMethod?: Maybe<LoginMethodEnum>;
  accountName?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  birthdate?: Maybe<Scalars['String']>;
  avatar?: Maybe<UploadShort>;
  banner?: Maybe<UploadShort>;
  gender: GenderEnum;
  about?: Maybe<RichTextContent>;
  createdAt: Scalars['String'];
  updatedAt: Scalars['String'];
  showSensitiveContent: Scalars['Boolean'];
  userStatus: UserStatusEnum;
  userType: UserTypeEnum;
  creatorType: CreatorType;
  locale?: Maybe<LocaleEnum>;
  blurPostCount: BlurPostCount;
  hasCurrentUserFollowed?: Maybe<Scalars['Boolean']>;
  shortCaption?: Maybe<Scalars['String']>;
  postCount: Scalars['Int'];
  currentMonthPostCount: Scalars['Int'];
  followerCount: Scalars['Int'];
  followingCount: Scalars['Int'];
  subscriberCount: Scalars['Int'];
  channels: Array<Maybe<Channel>>;
  notificationLastSeen?: Maybe<Scalars['String']>;
  messageLastSeen?: Maybe<Scalars['String']>;
  pubnubAuthKey?: Maybe<Scalars['String']>;
  walletAccount?: Maybe<Scalars['String']>;
  creditBalance?: Maybe<Scalars['Int']>;
};


export type UserAvatarArgs = {
  imageSize?: Maybe<ImageSizeInput>;
};


export type UserBannerArgs = {
  imageSize?: Maybe<ImageSizeInput>;
};


export type UserPostCountArgs = {
  postTypes?: Maybe<Array<Maybe<PostTypeEnum>>>;
};


export type UserCurrentMonthPostCountArgs = {
  postTypes?: Maybe<Array<Maybe<PostTypeEnum>>>;
};

export type UserPage = {
  __typename?: 'UserPage';
  users: Array<Maybe<User>>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  count: Scalars['Int'];
  pageToken?: Maybe<Scalars['String']>;
};

export enum GenderEnum {
  Male = 'MALE',
  Female = 'FEMALE',
  Other = 'OTHER'
}

export enum LocaleEnum {
  Zh = 'ZH',
  En = 'EN'
}

export enum UserStatusEnum {
  Active = 'ACTIVE',
  Removed = 'REMOVED',
  Banned = 'BANNED'
}

export enum UserTypeEnum {
  NormalUser = 'NORMAL_USER',
  Creator = 'CREATOR'
}

export enum CreatorTypeEnum {
  Lite = 'LITE',
  Pro = 'PRO'
}

export enum AccountNameValidationStatusEnum {
  Valid = 'VALID',
  Used = 'USED',
  Inappropriate = 'INAPPROPRIATE'
}

export enum LoginMethodEnum {
  Google = 'GOOGLE',
  Facebook = 'FACEBOOK',
  Twitter = 'TWITTER',
  Email = 'EMAIL',
  Unknown = 'UNKNOWN'
}

export type UpdateUserInput = {
  _id?: Maybe<Scalars['ID']>;
  accountName?: Maybe<Scalars['ID']>;
  displayName?: Maybe<Scalars['String']>;
  birthdate?: Maybe<Scalars['String']>;
  avatar?: Maybe<UserUploadInput>;
  banner?: Maybe<UserUploadInput>;
  gender?: Maybe<GenderEnum>;
  about?: Maybe<UpdateRichTextInput>;
  locale?: Maybe<LocaleEnum>;
  shortCaption?: Maybe<Scalars['String']>;
  showSensitiveContent?: Maybe<Scalars['Boolean']>;
};

export type UserInput = {
  id?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
};

export type UserUploadInput = {
  intrinsicSize: IntrinsicSizeInput;
  url: Scalars['String'];
  filepath: Scalars['String'];
};

export type TagInput = {
  value?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  bgImage?: Maybe<Scalars['String']>;
};

export type Tag = {
  __typename?: 'Tag';
  _id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  bgImage?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  hasCurrentUserFollowed?: Maybe<Scalars['Boolean']>;
};

export enum SubscriptionPlanStatusEnum {
  Published = 'PUBLISHED',
  Removed = 'REMOVED',
  Banned = 'BANNED'
}

export enum CurrentUserSubscriptionStatusEnum {
  Subscribe = 'SUBSCRIBE',
  Subscribed = 'SUBSCRIBED',
  Upgrade = 'UPGRADE',
  SubscribedWithHigherPrice = 'SUBSCRIBED_WITH_HIGHER_PRICE',
  Owner = 'OWNER',
  InvalidSubscriptionPlan = 'INVALID_SUBSCRIPTION_PLAN'
}

export enum SubscriptionPlanBenefitsEnum {
  PrivateMessages = 'PRIVATE_MESSAGES',
  UnlockContent = 'UNLOCK_CONTENT',
  UnblurLevel1 = 'UNBLUR_LEVEL1',
  UnblurLevel2 = 'UNBLUR_LEVEL2',
  UnblurLevel3 = 'UNBLUR_LEVEL3',
  Comments = 'COMMENTS'
}

export enum SubscriptionPlanPeriodEnum {
  Monthly = 'MONTHLY',
  HalfYearly = 'HALF_YEARLY',
  Creation = 'CREATION'
}

export type UpdateSubscriptionPlanInput = {
  _id: Scalars['ID'];
  slug: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  channelIds: Array<Scalars['String']>;
  subscriptionPlanStatus: SubscriptionPlanStatusEnum;
  content?: Maybe<UpdateRichTextInput>;
  image?: Maybe<UploadInput>;
  price: Scalars['Float'];
  plan?: Maybe<SubscriptionPlanPeriodEnum>;
  benefits?: Maybe<Array<Maybe<SubscriptionPlanBenefitsEnum>>>;
  currency?: Maybe<CurrencyEnum>;
  fileInput?: Maybe<UploadFileInput>;
};

export type CreateSubscriptionPlanInput = {
  title?: Maybe<Scalars['String']>;
  channelIds: Array<Scalars['String']>;
  content?: Maybe<UpdateRichTextInput>;
  image?: Maybe<UploadInput>;
  price: Scalars['Float'];
  plan?: Maybe<SubscriptionPlanPeriodEnum>;
  benefits?: Maybe<Array<Maybe<SubscriptionPlanBenefitsEnum>>>;
  currency?: Maybe<CurrencyEnum>;
  fileInput?: Maybe<UploadFileInput>;
};

export type SubscriptionPlanStatusHistory = {
  __typename?: 'SubscriptionPlanStatusHistory';
  action: SubscriptionPlanStatusEnum;
  createdAt: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type SubscriptionPlan = {
  __typename?: 'SubscriptionPlan';
  _id: Scalars['ID'];
  id: Scalars['String'];
  slug: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  channelIds: Array<Maybe<Scalars['String']>>;
  image?: Maybe<UploadShort>;
  price: Scalars['Float'];
  plan?: Maybe<SubscriptionPlanPeriodEnum>;
  subscriptionPlanStatusHistory?: Maybe<Array<Maybe<SubscriptionPlanStatusHistory>>>;
  subscriptionPlanStatus: SubscriptionPlanStatusEnum;
  writerId: Scalars['String'];
  content?: Maybe<RichTextContent>;
  createdAt: Scalars['String'];
  updatedAt: Scalars['String'];
  benefits?: Maybe<Array<Maybe<SubscriptionPlanBenefitsEnum>>>;
  currency?: Maybe<CurrencyEnum>;
  currentUserSubscriptionStatus: CurrentUserSubscriptionStatusEnum;
  writer?: Maybe<User>;
  channels?: Maybe<Array<Maybe<Channel>>>;
  posts?: Maybe<Array<Maybe<Post>>>;
};

export type SubscriptionPlanPage = {
  __typename?: 'SubscriptionPlanPage';
  items?: Maybe<Array<Maybe<SubscriptionPlan>>>;
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  pageToken?: Maybe<Scalars['String']>;
};

export type RichTextContent = {
  __typename?: 'RichTextContent';
  stringifyed?: Maybe<Scalars['String']>;
  serialized?: Maybe<Scalars['String']>;
};

export type UpdateRichTextInput = {
  stringifyed?: Maybe<Scalars['String']>;
  serialized?: Maybe<Scalars['String']>;
};

export type Like = {
  __typename?: 'Like';
  _id: Scalars['ID'];
  postId?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type LikeInput = {
  postId: Scalars['String'];
};

export enum CurrencyEnum {
  Usd = 'USD',
  Hkd = 'HKD'
}

export enum UserSubscriptionPlanStatusEnum {
  Active = 'ACTIVE',
  Cancel = 'CANCEL',
  CancelledBeforePaid = 'CANCELLED_BEFORE_PAID',
  CancelledByUser = 'CANCELLED_BY_USER',
  PaymentFailed = 'PAYMENT_FAILED',
  Deleted = 'DELETED'
}

export enum UserSubscriptionPlanTypeEnum {
  Normal = 'NORMAL',
  SinglePurchase = 'SINGLE_PURCHASE'
}

export enum UserSubscriptionPlanBadgeEnum {
  SinglePurchase = 'SINGLE_PURCHASE',
  Active = 'ACTIVE',
  ActiveUntilMonth = 'ACTIVE_UNTIL_MONTH',
  PaymentFailed = 'PAYMENT_FAILED',
  Cancel = 'CANCEL',
  CancelWithHeightPrice = 'CANCEL_WITH_HEIGHT_PRICE'
}

export type SubscriberPageInput = {
  writerId: Scalars['String'];
  subscriptionPlanId?: Maybe<Scalars['String']>;
  period?: Maybe<PeriodInput>;
  userSubscriptionPlanStatus: Array<UserSubscriptionPlanStatusEnum>;
};

export type UserSubscriptionPageInput = {
  userId: Scalars['String'];
  isActive: Scalars['Boolean'];
};

export type SubscriberPageForCmsInput = {
  writerId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  subscriptionPlanId?: Maybe<Scalars['String']>;
  period?: Maybe<PeriodInput>;
  userSubscriptionPlanStatus?: Maybe<Array<UserSubscriptionPlanStatusEnum>>;
};

export type UserSubscriptionPlan = {
  __typename?: 'UserSubscriptionPlan';
  _id: Scalars['ID'];
  id?: Maybe<Scalars['ID']>;
  userId: Scalars['String'];
  subscriptionPlanId: Scalars['String'];
  writerId?: Maybe<Scalars['String']>;
  paymentPeriod: SubscriptionPlanPeriodEnum;
  userSubscriptionPlanStatus: UserSubscriptionPlanStatusEnum;
  userSubscriptionPlanType: UserSubscriptionPlanTypeEnum;
  subscriptionPlan: SubscriptionPlan;
  startAt?: Maybe<Scalars['String']>;
  endAt?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  updatedAt: Scalars['String'];
  cancelledAt?: Maybe<Scalars['String']>;
  user: User;
  writer: User;
  latestInvoicesStatus?: Maybe<UserInvoiceTypeEnum>;
  currentSubscriptionStatus?: Maybe<UserSubscriptionPlanBadgeEnum>;
  priceBreakdown?: Maybe<PriceBreakdown>;
};

export type PriceBreakdown = {
  __typename?: 'priceBreakdown';
  price?: Maybe<Scalars['Float']>;
  totalIncome?: Maybe<Scalars['Float']>;
  providerFee?: Maybe<Scalars['Float']>;
  platformFee?: Maybe<Array<Maybe<PlatformfeeBreakDown>>>;
  totalPeriod?: Maybe<Scalars['Int']>;
};

export type PlatformfeeBreakDown = {
  __typename?: 'platformfeeBreakDown';
  subscriptionPeriod: Scalars['Int'];
  writerPlatformFee: Scalars['Float'];
};

export type CreateUserSubscriptionPlanResponse = {
  __typename?: 'CreateUserSubscriptionPlanResponse';
  paymentMethodId: Scalars['String'];
  priceId: Scalars['String'];
  subscription?: Maybe<Stripe_Subscription>;
};

export type StripePaymentResponse = {
  __typename?: 'StripePaymentResponse';
  success: Scalars['Boolean'];
  requiresAction: Scalars['Boolean'];
  paymentIntentClientSecret: Scalars['String'];
};

export type UserSubscriptionPlanPage = {
  __typename?: 'UserSubscriptionPlanPage';
  items: Array<Maybe<UserSubscriptionPlan>>;
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  pageToken?: Maybe<Scalars['String']>;
};

export type UserSubscriptionPage = {
  __typename?: 'UserSubscriptionPage';
  items: Array<Maybe<UserSubscriptionPlan>>;
  paging: CursorPagingInfo;
};

export type FollowUser = {
  __typename?: 'FollowUser';
  _id: Scalars['ID'];
  writerId: Scalars['ID'];
  userId: Scalars['ID'];
  writer: User;
  user: User;
  createdAt: Scalars['String'];
};

export type FollowUserPage = {
  __typename?: 'FollowUserPage';
  items: Array<Maybe<FollowUser>>;
  paging: CursorPagingInfo;
};

export type FollowTag = {
  __typename?: 'FollowTag';
  tagId: Scalars['ID'];
  userId: Scalars['ID'];
  tag?: Maybe<Tag>;
};

export type FollowTagPage = {
  __typename?: 'FollowTagPage';
  items: Array<Maybe<FollowTag>>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  count: Scalars['Int'];
  pageToken?: Maybe<Scalars['String']>;
};

export enum ChannelStatusEnum {
  Published = 'PUBLISHED',
  Pending = 'PENDING',
  Removed = 'REMOVED',
  Banned = 'BANNED'
}

export type Channel = {
  __typename?: 'Channel';
  _id: Scalars['String'];
  id: Scalars['String'];
  title: Scalars['String'];
  tagIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  creatorId: Scalars['String'];
  creator: User;
  /** @deprecated This field has been replaced by CreatorId */
  editorIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  isSensitive: Scalars['Boolean'];
  isCommentRestricted?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  channelStatus: ChannelStatusEnum;
  postCount: Scalars['Int'];
  currentMonthPostCount: Scalars['Int'];
  followerCount: Scalars['Int'];
  subscriberCount: Scalars['Int'];
  subscriptionCount: Scalars['Int'];
  blurPostCount: BlurPostCount;
};


export type ChannelPostCountArgs = {
  postTypes?: Maybe<Array<Maybe<PostTypeEnum>>>;
};


export type ChannelCurrentMonthPostCountArgs = {
  postTypes?: Maybe<Array<Maybe<PostTypeEnum>>>;
};

export type UpdateChannelResponse = {
  __typename?: 'UpdateChannelResponse';
  channel: Channel;
  notification?: Maybe<Notification>;
};

export type UpdateChannelInput = {
  _id: Scalars['String'];
  title: Scalars['String'];
  isSensitive: Scalars['Boolean'];
  isCommentRestricted?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
};

export type Notification = {
  __typename?: 'Notification';
  _id: Scalars['ID'];
  userId?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  relatedUserId?: Maybe<Scalars['String']>;
  relatedUser?: Maybe<User>;
  postId?: Maybe<Scalars['String']>;
  post?: Maybe<Post>;
  subscriptionPlanId?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<SubscriptionPlan>;
  userPayoutId?: Maybe<Scalars['String']>;
  userPayout?: Maybe<UserPayout>;
  commentId?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  channel?: Maybe<Channel>;
  type: NotificationTypeEnum;
  notificationStatus: NotificationStatusEnum;
  startAt?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  updatedAt: Scalars['String'];
  transactionHash?: Maybe<Scalars['String']>;
};

export type NotificationPage = {
  __typename?: 'NotificationPage';
  items: Array<Maybe<Notification>>;
  count: Scalars['Int'];
  paging: CursorPagingInfo;
};

export type NftNotificationResponse = {
  __typename?: 'NftNotificationResponse';
  notification?: Maybe<Notification>;
  asset?: Maybe<NftInfo>;
};

export enum NotificationTypeEnum {
  PostNew = 'POST_NEW',
  PostChannelNew = 'POST_CHANNEL_NEW',
  PostEdit = 'POST_EDIT',
  SubscriptionPlanNew = 'SUBSCRIPTION_PLAN_NEW',
  SubscriptionPlanUpdate = 'SUBSCRIPTION_PLAN_UPDATE',
  SubscriptionPlanRemove = 'SUBSCRIPTION_PLAN_REMOVE',
  SubscriptionPlanSpecialOffer = 'SUBSCRIPTION_PLAN_SPECIAL_OFFER',
  SubscriptionSuccess = 'SUBSCRIPTION_SUCCESS',
  SubscriptionCancel = 'SUBSCRIPTION_CANCEL',
  SubscriptionReactivate = 'SUBSCRIPTION_REACTIVATE',
  PurchaseSuccess = 'PURCHASE_SUCCESS',
  PaymentFail = 'PAYMENT_FAIL',
  UserNew = 'USER_NEW',
  Comment = 'COMMENT',
  UserBanned = 'USER_BANNED',
  UserUnbanned = 'USER_UNBANNED',
  FollowerChannelNew = 'FOLLOWER_CHANNEL_NEW',
  FollowerNew = 'FOLLOWER_NEW',
  SubscriptionNew = 'SUBSCRIPTION_NEW',
  PurchaseNew = 'PURCHASE_NEW',
  PostLike = 'POST_LIKE',
  PostComment = 'POST_COMMENT',
  PostBanned = 'POST_BANNED',
  PostUnbanned = 'POST_UNBANNED',
  PayoutSucceeded = 'PAYOUT_SUCCEEDED',
  PayoutFailed = 'PAYOUT_FAILED',
  PayoutRefunded = 'PAYOUT_REFUNDED',
  PayoutUnclaimed = 'PAYOUT_UNCLAIMED',
  PayoutProcessing = 'PAYOUT_PROCESSING',
  CreatorSubscriptionPlanUnbanned = 'CREATOR_SUBSCRIPTION_PLAN_UNBANNED',
  CreatorSubscriptionPlanBanned = 'CREATOR_SUBSCRIPTION_PLAN_BANNED',
  CreatorSubscriptionPlanUpdate = 'CREATOR_SUBSCRIPTION_PLAN_UPDATE',
  NftConfirmpurchaseNotifyBuyer = 'NFT_CONFIRMPURCHASE_NOTIFY_BUYER',
  NftConfirmpurchaseNotifySeller = 'NFT_CONFIRMPURCHASE_NOTIFY_SELLER',
  NftConfirmlist = 'NFT_CONFIRMLIST',
  NftConfirmCancellist = 'NFT_CONFIRM_CANCELLIST',
  NftConfirmUpdatelist = 'NFT_CONFIRM_UPDATELIST',
  ChannelNewNft = 'CHANNEL_NEW_NFT',
  ApplicationCreatorSubmitted = 'APPLICATION_CREATOR_SUBMITTED',
  ApplicationCreatorRejected = 'APPLICATION_CREATOR_REJECTED',
  ApplicationCreatorApproved = 'APPLICATION_CREATOR_APPROVED',
  ApplicationCreatorReexamine = 'APPLICATION_CREATOR_REEXAMINE',
  ChannelStatusPublished = 'CHANNEL_STATUS_PUBLISHED',
  ChannelStatusPending = 'CHANNEL_STATUS_PENDING',
  ChannelStatusBanned = 'CHANNEL_STATUS_BANNED',
  ChannelStatusRemoved = 'CHANNEL_STATUS_REMOVED',
  ChannelStatusRemovedByAdmin = 'CHANNEL_STATUS_REMOVED_BY_ADMIN'
}

export enum NotificationStatusEnum {
  Read = 'READ',
  NotRead = 'NOT_READ',
  Removed = 'REMOVED'
}

export type UpdateNotificationInput = {
  _id: Scalars['String'];
  notificationStatus: NotificationStatusEnum;
};

export type ConfirmNftPurchaseInput = {
  transactionHash: Scalars['String'];
  tokenId: Scalars['String'];
};

export enum CommentStatusEnum {
  Active = 'ACTIVE',
  Removed = 'REMOVED',
  Banned = 'BANNED'
}

export type Comment = {
  __typename?: 'Comment';
  _id: Scalars['String'];
  parentCommentId?: Maybe<Scalars['String']>;
  postWriterId: Scalars['String'];
  postId: Scalars['String'];
  userId: Scalars['String'];
  mentionUserIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  content: Scalars['String'];
  commentStatus: CommentStatusEnum;
  updatedAt: Scalars['String'];
  createdAt: Scalars['String'];
  user: User;
  mentionUsers?: Maybe<Array<Maybe<User>>>;
  numberOfReplies: Scalars['Int'];
};

export type CommentPage = {
  __typename?: 'CommentPage';
  items: Array<Maybe<Comment>>;
  paging: CursorPagingInfo;
};

export type CreateCommentInput = {
  content: Scalars['String'];
  parentCommentId?: Maybe<Scalars['String']>;
  postId: Scalars['String'];
  mentionUserIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CommentPageInput = {
  postId: Scalars['String'];
  parentCommentId?: Maybe<Scalars['String']>;
};

export type FollowChannel = {
  __typename?: 'FollowChannel';
  _id: Scalars['ID'];
  userId: Scalars['ID'];
  channelId: Scalars['ID'];
  createdAt: Scalars['String'];
  user: User;
  channel: Channel;
};

export type FollowChannelPage = {
  __typename?: 'FollowChannelPage';
  items: Array<Maybe<FollowChannel>>;
  paging: CursorPagingInfo;
};

export type FollowChannelQueryInput = {
  userId?: Maybe<Scalars['String']>;
  channelId?: Maybe<Scalars['String']>;
  creatorId?: Maybe<Scalars['String']>;
};

export type Chat = {
  __typename?: 'Chat';
  _id: Scalars['ID'];
  userIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  lastMessage?: Maybe<Message>;
  users?: Maybe<Array<Maybe<User>>>;
  relatedUser?: Maybe<User>;
};

export type InitialChat = {
  __typename?: 'InitialChat';
  _id?: Maybe<Scalars['ID']>;
  relatedUser?: Maybe<User>;
};

export type ChatPage = {
  __typename?: 'ChatPage';
  items?: Maybe<Array<Maybe<Chat>>>;
  paging: CursorPagingInfo;
};

export enum MessageStatusEnum {
  Sending = 'SENDING',
  Active = 'ACTIVE',
  Edited = 'EDITED',
  Removed = 'REMOVED'
}

export type Message = {
  __typename?: 'Message';
  _id: Scalars['ID'];
  chatId: Scalars['String'];
  senderId: Scalars['String'];
  receiverId: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  files?: Maybe<Array<Maybe<UploadShort>>>;
  read: Scalars['Boolean'];
  messageStatus: MessageStatusEnum;
  createdAt: Scalars['String'];
  updatedAt: Scalars['String'];
  sender: User;
  receiver: User;
};

export type MessagePage = {
  __typename?: 'MessagePage';
  items?: Maybe<Array<Maybe<Message>>>;
  paging: CursorPagingInfo;
  /**
   * used in mutation update function only, no resolver is needed
   * @deprecated using cache modify will return directly (skipping the merge fn in type policies
   */
  mergedManually?: Maybe<Scalars['Boolean']>;
};

export type CreateMessageInput = {
  _id: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  files?: Maybe<UploadFileInput>;
  receiverId: Scalars['String'];
  chatId: Scalars['String'];
};

export type UpdateMessageInput = {
  message: Scalars['String'];
  messageId: Scalars['String'];
};

export type Card = {
  __typename?: 'Card';
  lastFourDigits: Scalars['String'];
  brand: Scalars['String'];
  expMonth: Scalars['Int'];
  expYear: Scalars['Int'];
};

export enum PaymentMethodStatusEnum {
  Default = 'DEFAULT',
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Removed = 'REMOVED'
}

export enum PaymentMethodProviderEnum {
  Stripe = 'STRIPE',
  Stripe2 = 'STRIPE2',
  Credit = 'CREDIT'
}

export type Stripe_Payment_Intent = {
  __typename?: 'stripe_payment_intent';
  status: Scalars['String'];
  client_secret: Scalars['String'];
};

export type Stripe_Invoice = {
  __typename?: 'stripe_invoice';
  payment_intent?: Maybe<Stripe_Payment_Intent>;
};

export type Stripe_Subscription = {
  __typename?: 'stripe_subscription';
  id: Scalars['String'];
  status: Scalars['String'];
  latest_invoice: Stripe_Invoice;
};

export type PaymentMethodDetail = {
  __typename?: 'PaymentMethodDetail';
  card?: Maybe<Card>;
};

export type UserPaymentMethod = {
  __typename?: 'UserPaymentMethod';
  _id: Scalars['String'];
  userId: Scalars['String'];
  refId: Scalars['String'];
  provider: PaymentMethodProviderEnum;
  paymentMethodStatus: PaymentMethodStatusEnum;
  paymentMethodDetail: PaymentMethodDetail;
};

export type Invoice = {
  __typename?: 'Invoice';
  url?: Maybe<Scalars['String']>;
  pdf?: Maybe<Scalars['String']>;
};

export type UserInvoice = {
  __typename?: 'UserInvoice';
  _id: Scalars['String'];
  id: Scalars['String'];
  userId: Scalars['String'];
  refId: Scalars['String'];
  invoice?: Maybe<Invoice>;
  subscriptionPlanId: Scalars['String'];
  subscriptionPlan?: Maybe<SubscriptionPlan>;
  provider: PaymentMethodProviderEnum;
  userInvoiceStatus: UserInvoiceStatusEnum;
  refundedAmount?: Maybe<Scalars['Float']>;
  type?: Maybe<UserInvoiceTypeEnum>;
  startAt?: Maybe<Scalars['String']>;
  endAt?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  updatedAt: Scalars['String'];
  writerIncome: Scalars['Float'];
  writerPlatformFee: Scalars['Float'];
  writerProviderFee: Scalars['Float'];
};

export type UserInvoicePage = {
  __typename?: 'UserInvoicePage';
  items: Array<Maybe<UserInvoice>>;
  paging: CursorPagingInfo;
};

export enum UserInvoiceStatusEnum {
  Paid = 'PAID',
  Open = 'OPEN',
  Refunded = 'REFUNDED',
  Duplicated = 'DUPLICATED'
}

export enum UserInvoiceTypeEnum {
  Subscription = 'SUBSCRIPTION',
  SinglePurchase = 'SINGLE_PURCHASE',
  Tips = 'TIPS'
}

export type TopPost = {
  __typename?: 'TopPost';
  _id: Scalars['ID'];
  postId: Scalars['String'];
  locale: LocaleEnum;
  likes: Scalars['Int'];
  post?: Maybe<Post>;
};

export type TopTag = {
  __typename?: 'TopTag';
  _id: Scalars['ID'];
  value: Scalars['String'];
  label: Scalars['String'];
};

export type TopWriter = {
  __typename?: 'TopWriter';
  _id: Scalars['ID'];
  userId: Scalars['String'];
  locale: LocaleEnum;
  score: Scalars['Int'];
  user?: Maybe<User>;
};

export type TopWriterPage = {
  __typename?: 'TopWriterPage';
  items?: Maybe<Array<Maybe<TopWriter>>>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  count: Scalars['Int'];
  pageToken?: Maybe<Scalars['String']>;
};

export enum UpdatePeriodEnum {
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export enum CacheControlScope {
  Public = 'PUBLIC',
  Private = 'PRIVATE'
}

export type CreateUserReceivePaymentMethodInput = {
  provider: ReceivePaymentMethodProviderEnum;
  email?: Maybe<Scalars['String']>;
  bankAccount?: Maybe<Scalars['String']>;
  bankAccountHolder?: Maybe<Scalars['String']>;
  currencyCode?: Maybe<Scalars['String']>;
  bank?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
};

export type UpdateUserReceivePaymentMethodInput = {
  _id: Scalars['String'];
  provider: ReceivePaymentMethodProviderEnum;
  email?: Maybe<Scalars['String']>;
  bankAccount?: Maybe<Scalars['String']>;
  bankAccountHolder?: Maybe<Scalars['String']>;
  currencyCode?: Maybe<Scalars['String']>;
  bank?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
};

export type UserReceivePaymentMethod = {
  __typename?: 'UserReceivePaymentMethod';
  _id: Scalars['String'];
  userId: Scalars['String'];
  autoTransfer: Scalars['Boolean'];
  userReceivePaymentMethodStatus: UserReceivePaymentMethodStatusEnum;
  provider: ReceivePaymentMethodProviderEnum;
  email?: Maybe<Scalars['String']>;
  bankAccount?: Maybe<Scalars['String']>;
  bankAccountHolder?: Maybe<Scalars['String']>;
  currencyCode?: Maybe<Scalars['String']>;
  bank?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
};

export enum UserReceivePaymentMethodStatusEnum {
  Active = 'ACTIVE',
  Default = 'DEFAULT',
  Inactive = 'INACTIVE'
}

export enum ReceivePaymentMethodProviderEnum {
  Paypal = 'PAYPAL',
  Payoneer = 'PAYONEER',
  Direct = 'DIRECT'
}

export type CreateUserPayoutInput = {
  value: Scalars['Float'];
  provider: ReceivePaymentMethodProviderEnum;
  currency: CurrencyEnum;
};

export type UserPayout = {
  __typename?: 'UserPayout';
  _id: Scalars['String'];
  userId: Scalars['String'];
  currency: CurrencyEnum;
  value: Scalars['Float'];
  userPayoutStatus: UserPayoutStatusEnum;
  provider: ReceivePaymentMethodProviderEnum;
  createdAt: Scalars['String'];
  updatedAt: Scalars['String'];
  remarks?: Maybe<Scalars['String']>;
  receiptUrl?: Maybe<Scalars['String']>;
};

export type UserPayoutPage = {
  __typename?: 'UserPayoutPage';
  items: Array<Maybe<UserPayout>>;
  paging: CursorPagingInfo;
};

export enum UserPayoutStatusEnum {
  Succeeded = 'SUCCEEDED',
  Failed = 'FAILED',
  Refunded = 'REFUNDED',
  Unclaimed = 'UNCLAIMED',
  Processing = 'PROCESSING'
}

export enum UserPayoutRequestedByEnum {
  User = 'USER',
  Auto = 'AUTO',
  Admin = 'ADMIN'
}

export type PeriodInput = {
  startAt: Scalars['String'];
  endAt: Scalars['String'];
};

export type UserWallet = {
  __typename?: 'UserWallet';
  _id: Scalars['ID'];
  id: Scalars['String'];
  userId: Scalars['String'];
  income: Scalars['Float'];
  withdrawal: Scalars['Float'];
  currency: CurrencyEnum;
  openBalance: Scalars['Float'];
  startAt: Scalars['String'];
  detail: UserWalletBalance;
};

export type UserWalletBalance = {
  __typename?: 'UserWalletBalance';
  totalBalance: Scalars['Float'];
  balance: Scalars['Float'];
  isWithdrewOrProcessing: Scalars['Boolean'];
  balanceExcludeProcessingAmount: Scalars['Float'];
};

export type ImageSizeInput = {
  maxWidth?: Maybe<Scalars['Int']>;
  maxHeight?: Maybe<Scalars['Int']>;
};

export enum FeatureTypeEnum {
  PayoutMethod = 'PAYOUT_METHOD'
}

export enum FeatureNameEnum {
  Tips = 'TIPS',
  OfflinePayment = 'OFFLINE_PAYMENT',
  Subscription = 'SUBSCRIPTION',
  Paypal = 'PAYPAL',
  Direct = 'DIRECT',
  Pyoneer = 'PYONEER',
  Nft = 'NFT',
  DirectMessage = 'DIRECT_MESSAGE',
  Search = 'SEARCH',
  VideoPost = 'VIDEO_POST'
}

export enum TransactionActionTypeEnum {
  Mint = 'MINT',
  ApproveAll = 'APPROVE_ALL',
  List = 'LIST',
  CancelList = 'CANCEL_LIST',
  Buy = 'BUY',
  GenerateIpfsCid = 'GENERATE_IPFS_CID',
  UpdateTokenCid = 'UPDATE_TOKEN_CID',
  UpdateListedPrice = 'UPDATE_LISTED_PRICE'
}

export type Application = {
  __typename?: 'Application';
  _id: Scalars['ID'];
  userId: Scalars['String'];
  name: Scalars['String'];
  bankAccount: Scalars['String'];
  address: Scalars['String'];
  phoneNumber: Scalars['String'];
  postalCode?: Maybe<Scalars['String']>;
  introduction?: Maybe<Scalars['String']>;
  identityDocument: UploadShort;
  status: ApplicationStatusEnum;
  type: ApplicationTypeEnum;
};

export type SubmittedApplicationResponse = {
  __typename?: 'SubmittedApplicationResponse';
  application: Application;
  notification?: Maybe<Notification>;
};

export enum ApplicationTypeEnum {
  Creator = 'CREATOR'
}

export enum ApplicationStatusEnum {
  Pending = 'PENDING',
  Approved = 'APPROVED',
  Rejected = 'REJECTED'
}

export type CreateApplicationInput = {
  name: Scalars['String'];
  address: Scalars['String'];
  phoneNumber: Scalars['String'];
  postalCode?: Maybe<Scalars['String']>;
  type: ApplicationTypeEnum;
};

export type UpdateApplicationInput = {
  _id: Scalars['ID'];
  name: Scalars['String'];
  address: Scalars['String'];
  phoneNumber: Scalars['String'];
  postalCode?: Maybe<Scalars['String']>;
  type: ApplicationTypeEnum;
};

export enum UserRefundStatusEnum {
  Pending = 'PENDING',
  Failed = 'FAILED',
  Succeeded = 'SUCCEEDED'
}


export type ApplicationFragment = (
  { __typename?: 'Application' }
  & Pick<Application, '_id' | 'type' | 'status' | 'userId' | 'name' | 'phoneNumber' | 'postalCode' | 'address'>
);

export type CreateApplicationMutationVariables = Exact<{
  input: CreateApplicationInput;
}>;


export type CreateApplicationMutation = (
  { __typename?: 'Mutation' }
  & { createApplication: (
    { __typename?: 'SubmittedApplicationResponse' }
    & { application: (
      { __typename?: 'Application' }
      & ApplicationFragment
    ), notification?: Maybe<(
      { __typename?: 'Notification' }
      & NotificationFullFragment
    )> }
  ) }
);

export type UpdateApplicationMutationVariables = Exact<{
  input: UpdateApplicationInput;
}>;


export type UpdateApplicationMutation = (
  { __typename?: 'Mutation' }
  & { updateApplication: (
    { __typename?: 'SubmittedApplicationResponse' }
    & { application: (
      { __typename?: 'Application' }
      & ApplicationFragment
    ), notification?: Maybe<(
      { __typename?: 'Notification' }
      & NotificationFullFragment
    )> }
  ) }
);

export type ApplicationQueryVariables = Exact<{
  type: ApplicationTypeEnum;
}>;


export type ApplicationQuery = (
  { __typename?: 'Query' }
  & { application?: Maybe<(
    { __typename?: 'Application' }
    & ApplicationFragment
  )> }
);

export type IsTestUserQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type IsTestUserQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'isTestUser'>
);

export type ChannelFragment = (
  { __typename?: 'Channel' }
  & Pick<Channel, '_id' | 'id' | 'title' | 'slug' | 'creatorId' | 'description' | 'isSensitive' | 'isCommentRestricted' | 'channelStatus'>
  & { creator: (
    { __typename?: 'User' }
    & Pick<User, 'accountName'>
  ) }
);

export type ChannelPostCountFragment = (
  { __typename?: 'Channel' }
  & Pick<Channel, 'postCount' | 'currentMonthPostCount'>
);

export type ChannelSubscribeContentCountFragment = (
  { __typename?: 'Channel' }
  & Pick<Channel, 'subscriberCount'>
  & { blurPostCount: (
    { __typename?: 'BlurPostCount' }
    & Pick<BlurPostCount, 'currentMonth' | 'lastMonth' | 'total'>
  ) }
);

export type ChannelFollowCountFragment = (
  { __typename?: 'Channel' }
  & Pick<Channel, 'followerCount'>
);

export type CreateChannelMutationVariables = Exact<{
  title: Scalars['String'];
  isSensitive: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  isCommentRestricted?: Maybe<Scalars['Boolean']>;
}>;


export type CreateChannelMutation = (
  { __typename?: 'Mutation' }
  & { createChannel: (
    { __typename?: 'Channel' }
    & ChannelFragment
  ) }
);

export type RemoveChannelMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type RemoveChannelMutation = (
  { __typename?: 'Mutation' }
  & { removeChannel: (
    { __typename?: 'Channel' }
    & ChannelFragment
  ) }
);

export type UpdateChannelMutationVariables = Exact<{
  input: UpdateChannelInput;
}>;


export type UpdateChannelMutation = (
  { __typename?: 'Mutation' }
  & { updateChannel: (
    { __typename?: 'UpdateChannelResponse' }
    & { channel: (
      { __typename?: 'Channel' }
      & ChannelFragment
    ), notification?: Maybe<(
      { __typename?: 'Notification' }
      & NotificationFullFragment
    )> }
  ) }
);

export type ChannelsQueryVariables = Exact<{
  userId?: Maybe<Scalars['String']>;
  postTypes?: Maybe<Array<Maybe<PostTypeEnum>> | Maybe<PostTypeEnum>>;
  channelStatus?: Maybe<Array<ChannelStatusEnum> | ChannelStatusEnum>;
  skipCount?: Maybe<Scalars['Boolean']>;
}>;


export type ChannelsQuery = (
  { __typename?: 'Query' }
  & { channels?: Maybe<Array<Maybe<(
    { __typename?: 'Channel' }
    & MakeOptional<Pick<Channel, 'postCount' | 'followerCount' | 'subscriptionCount'>, 'postCount' | 'followerCount' | 'subscriptionCount'>
    & ChannelFragment
  )>>> }
);

export type ProfileChannelQueryVariables = Exact<{
  channelSlug: Scalars['String'];
}>;


export type ProfileChannelQuery = (
  { __typename?: 'Query' }
  & { channel?: Maybe<(
    { __typename?: 'Channel' }
    & ChannelFragment
    & ChannelFollowCountFragment
  )> }
);

export type ProfileChannelPostCountQueryVariables = Exact<{
  channelSlug: Scalars['String'];
  postTypes?: Maybe<Array<Maybe<PostTypeEnum>> | Maybe<PostTypeEnum>>;
}>;


export type ProfileChannelPostCountQuery = (
  { __typename?: 'Query' }
  & { channel?: Maybe<(
    { __typename?: 'Channel' }
    & Pick<Channel, '_id'>
    & ChannelPostCountFragment
    & ChannelSubscribeContentCountFragment
  )> }
);

export type CommentFragment = (
  { __typename?: 'Comment' }
  & Pick<Comment, '_id' | 'parentCommentId' | 'postWriterId' | 'postId' | 'userId' | 'mentionUserIds' | 'content' | 'commentStatus' | 'updatedAt' | 'createdAt' | 'numberOfReplies'>
  & { user: (
    { __typename?: 'User' }
    & UserBasicInfoFragment
  ), mentionUsers?: Maybe<Array<Maybe<(
    { __typename?: 'User' }
    & UserBasicInfoFragment
  )>>> }
);

export type RemoveCommentMutationVariables = Exact<{
  commentId: Scalars['String'];
}>;


export type RemoveCommentMutation = (
  { __typename?: 'Mutation' }
  & { removeComment: (
    { __typename?: 'Comment' }
    & Pick<Comment, '_id' | 'parentCommentId' | 'commentStatus' | 'postId'>
  ) }
);

export type CommentPageQueryVariables = Exact<{
  input: CommentPageInput;
  avatarSize?: Maybe<ImageSizeInput>;
  paging?: Maybe<CursorPagingInput>;
}>;


export type CommentPageQuery = (
  { __typename?: 'Query' }
  & { commentPage?: Maybe<(
    { __typename?: 'CommentPage' }
    & { items: Array<Maybe<(
      { __typename?: 'Comment' }
      & CommentFragment
    )>>, paging: (
      { __typename?: 'CursorPagingInfo' }
      & CursorPagingInfoFragment
    ) }
  )> }
);

export type CreateCommentMutationVariables = Exact<{
  input: CreateCommentInput;
  avatarSize?: Maybe<ImageSizeInput>;
}>;


export type CreateCommentMutation = (
  { __typename?: 'Mutation' }
  & { createComment: (
    { __typename?: 'Comment' }
    & CommentFragment
  ) }
);

export type CursorPagingInfoFragment = (
  { __typename?: 'CursorPagingInfo' }
  & Pick<CursorPagingInfo, 'hasNext' | 'next'>
);

export type EnabledFeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type EnabledFeaturesQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'enabledFeatures'>
);

export type FollowChannelFragment = (
  { __typename?: 'FollowChannel' }
  & Pick<FollowChannel, 'channelId' | 'userId'>
);

export type FollowChannelPageFragment = (
  { __typename?: 'FollowChannelPage' }
  & { items: Array<Maybe<(
    { __typename?: 'FollowChannel' }
    & Pick<FollowChannel, '_id' | 'userId' | 'channelId' | 'createdAt'>
    & { user?: Maybe<(
      { __typename?: 'User' }
      & UserBasicInfoFragment
    )>, channel: (
      { __typename?: 'Channel' }
      & FollowingChannelFragment
    ) }
  )>>, paging: (
    { __typename?: 'CursorPagingInfo' }
    & CursorPagingInfoFragment
  ) }
);

export type FollowingChannelFragment = (
  { __typename?: 'Channel' }
  & Pick<Channel, 'postCount'>
  & { creator?: Maybe<(
    { __typename?: 'User' }
    & UserBasicInfoFragment
  )> }
  & ChannelFragment
);

export type FollowChannelMutationVariables = Exact<{
  input: Scalars['ID'];
}>;


export type FollowChannelMutation = (
  { __typename?: 'Mutation' }
  & { followChannel: (
    { __typename?: 'FollowChannel' }
    & FollowChannelFragment
  ) }
);

export type UnfollowChannelMutationVariables = Exact<{
  input: Scalars['ID'];
}>;


export type UnfollowChannelMutation = (
  { __typename?: 'Mutation' }
  & { unfollowChannel: (
    { __typename?: 'FollowChannel' }
    & Pick<FollowChannel, 'channelId' | 'userId'>
  ) }
);

export type FollowChannelPageQueryVariables = Exact<{
  input: FollowChannelQueryInput;
  paging?: Maybe<CursorPagingInput>;
  includeUser: Scalars['Boolean'];
  includeCreator: Scalars['Boolean'];
  avatarSize?: Maybe<ImageSizeInput>;
}>;


export type FollowChannelPageQuery = (
  { __typename?: 'Query' }
  & { followChannelPage: (
    { __typename?: 'FollowChannelPage' }
    & FollowChannelPageFragment
  ) }
);

export type FollowChannelDocQueryVariables = Exact<{
  input: Scalars['ID'];
}>;


export type FollowChannelDocQuery = (
  { __typename?: 'Query' }
  & { followChannelDoc?: Maybe<(
    { __typename?: 'FollowChannel' }
    & FollowChannelFragment
  )> }
);

export type FollowTagMutationVariables = Exact<{
  input: Scalars['ID'];
}>;


export type FollowTagMutation = (
  { __typename?: 'Mutation' }
  & { followTag: (
    { __typename?: 'FollowTag' }
    & Pick<FollowTag, 'tagId' | 'userId'>
  ) }
);

export type FollowTagDocQueryVariables = Exact<{
  input: Scalars['ID'];
}>;


export type FollowTagDocQuery = (
  { __typename?: 'Query' }
  & { followTagDoc?: Maybe<(
    { __typename?: 'FollowTag' }
    & Pick<FollowTag, 'tagId' | 'userId'>
  )> }
);

export type FollowedTagFragment = (
  { __typename?: 'Tag' }
  & Pick<Tag, '_id' | 'value' | 'label' | 'bgImage'>
);

export type FollowTagPageQueryVariables = Exact<{
  input?: Maybe<SearchInput>;
}>;


export type FollowTagPageQuery = (
  { __typename?: 'Query' }
  & { followTagPage: (
    { __typename?: 'FollowTagPage' }
    & { items: Array<Maybe<(
      { __typename?: 'FollowTag' }
      & Pick<FollowTag, 'tagId' | 'userId'>
      & { tag?: Maybe<(
        { __typename?: 'Tag' }
        & FollowedTagFragment
      )> }
    )>> }
  ) }
);

export type UnfollowTagMutationVariables = Exact<{
  input: Scalars['ID'];
}>;


export type UnfollowTagMutation = (
  { __typename?: 'Mutation' }
  & { unfollowTag: (
    { __typename?: 'FollowTag' }
    & Pick<FollowTag, 'tagId' | 'userId'>
  ) }
);

export type FollowUserMutationVariables = Exact<{
  input: Scalars['ID'];
}>;


export type FollowUserMutation = (
  { __typename?: 'Mutation' }
  & { followUser: (
    { __typename?: 'FollowUser' }
    & Pick<FollowUser, 'writerId' | 'userId'>
  ) }
);

export type FollowUserDocQueryVariables = Exact<{
  input: Scalars['ID'];
}>;


export type FollowUserDocQuery = (
  { __typename?: 'Query' }
  & { followUserDoc?: Maybe<(
    { __typename?: 'FollowUser' }
    & Pick<FollowUser, 'writerId' | 'userId'>
  )> }
);

export type FollowUserPageQueryVariables = Exact<{
  userId?: Maybe<Scalars['String']>;
  writerId?: Maybe<Scalars['String']>;
  paging?: Maybe<CursorPagingInput>;
  includeUser: Scalars['Boolean'];
  avatarSize?: Maybe<ImageSizeInput>;
}>;


export type FollowUserPageQuery = (
  { __typename?: 'Query' }
  & { followUserPage: (
    { __typename?: 'FollowUserPage' }
    & { items: Array<Maybe<(
      { __typename?: 'FollowUser' }
      & Pick<FollowUser, '_id' | 'writerId' | 'userId' | 'createdAt'>
      & { writer?: Maybe<(
        { __typename?: 'User' }
        & UserBasicInfoFragment
        & UserFollowCountFragment
      )>, user?: Maybe<(
        { __typename?: 'User' }
        & UserFollowCountFragment
        & UserBasicInfoFragment
      )> }
    )>>, paging: (
      { __typename?: 'CursorPagingInfo' }
      & CursorPagingInfoFragment
    ) }
  ) }
);

export type UnfollowUserMutationVariables = Exact<{
  input: Scalars['ID'];
}>;


export type UnfollowUserMutation = (
  { __typename?: 'Mutation' }
  & { unfollowUser: (
    { __typename?: 'FollowUser' }
    & Pick<FollowUser, 'writerId' | 'userId'>
  ) }
);

export type CreateLikeMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type CreateLikeMutation = (
  { __typename?: 'Mutation' }
  & { createLike?: Maybe<(
    { __typename?: 'Like' }
    & LikeRelationshipFragment
  )> }
);

export type LikeRelationshipFragment = (
  { __typename?: 'Like' }
  & Pick<Like, 'postId' | 'userId'>
);

export type LikeQueryVariables = Exact<{
  input: Scalars['String'];
}>;


export type LikeQuery = (
  { __typename?: 'Query' }
  & { like?: Maybe<(
    { __typename?: 'Like' }
    & LikeRelationshipFragment
  )> }
);

export type RemoveLikeMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type RemoveLikeMutation = (
  { __typename?: 'Mutation' }
  & { removeLike?: Maybe<(
    { __typename?: 'Like' }
    & LikeRelationshipFragment
  )> }
);

export type ChatFragment = (
  { __typename?: 'Chat' }
  & Pick<Chat, '_id' | 'userIds'>
  & { relatedUser?: Maybe<(
    { __typename?: 'User' }
    & UserBasicInfoFragment
  )>, lastMessage?: Maybe<(
    { __typename?: 'Message' }
    & Pick<Message, 'senderId' | 'message' | 'messageStatus' | 'read' | 'createdAt'>
  )> }
);

export type ChatPageQueryVariables = Exact<{
  paging?: Maybe<CursorPagingInput>;
  avatarSize?: Maybe<ImageSizeInput>;
}>;


export type ChatPageQuery = (
  { __typename?: 'Query' }
  & { chatPage?: Maybe<(
    { __typename?: 'ChatPage' }
    & { items?: Maybe<Array<Maybe<(
      { __typename?: 'Chat' }
      & ChatFragment
    )>>>, paging: (
      { __typename?: 'CursorPagingInfo' }
      & CursorPagingInfoFragment
    ) }
  )> }
);

export type InitialChatQueryVariables = Exact<{
  input: UserInput;
  avatarSize?: Maybe<ImageSizeInput>;
}>;


export type InitialChatQuery = (
  { __typename?: 'Query' }
  & { initialChat?: Maybe<(
    { __typename?: 'InitialChat' }
    & Pick<InitialChat, '_id'>
    & { relatedUser?: Maybe<(
      { __typename?: 'User' }
      & UserBasicInfoFragment
    )> }
  )> }
);

export type MessageFragment = (
  { __typename?: 'Message' }
  & Pick<Message, '_id' | 'chatId' | 'senderId' | 'receiverId' | 'message' | 'read' | 'messageStatus' | 'createdAt' | 'updatedAt'>
  & { files?: Maybe<Array<Maybe<(
    { __typename?: 'UploadShort' }
    & UploadShortFragment
  )>>> }
);

export type ReadMessagesMutationVariables = Exact<{
  senderId: Scalars['String'];
}>;


export type ReadMessagesMutation = (
  { __typename?: 'Mutation' }
  & { readMessages: Array<Maybe<(
    { __typename?: 'Message' }
    & Pick<Message, '_id' | 'read'>
  )>> }
);

export type CreateMessageMutationVariables = Exact<{
  input: CreateMessageInput;
}>;


export type CreateMessageMutation = (
  { __typename?: 'Mutation' }
  & { createMessage: (
    { __typename?: 'Message' }
    & MessageFragment
  ) }
);

export type MessagePageQueryVariables = Exact<{
  input: SearchInput;
  currentUserId: Scalars['String'];
  relatedUserId: Scalars['String'];
  paging?: Maybe<CursorPagingInput>;
}>;


export type MessagePageQuery = (
  { __typename?: 'Query' }
  & { messagePage?: Maybe<(
    { __typename?: 'MessagePage' }
    & { items?: Maybe<Array<Maybe<(
      { __typename?: 'Message' }
      & MessageFragment
    )>>>, paging: (
      { __typename?: 'CursorPagingInfo' }
      & CursorPagingInfoFragment
    ) }
  )> }
);

export type HasMessageQueryVariables = Exact<{ [key: string]: never; }>;


export type HasMessageQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'hasMessage'>
);

export type NotificationFullFragment = (
  { __typename?: 'Notification' }
  & Pick<Notification, '_id' | 'relatedUserId' | 'postId' | 'subscriptionPlanId' | 'channelId' | 'userPayoutId' | 'commentId' | 'type' | 'notificationStatus' | 'startAt' | 'createdAt' | 'updatedAt'>
  & { relatedUser?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, '_id' | 'accountName' | 'displayName'>
  )>, post?: Maybe<(
    { __typename?: 'Post' }
    & Pick<Post, '_id' | 'slug' | 'title'>
  )>, subscriptionPlan?: Maybe<(
    { __typename?: 'SubscriptionPlan' }
    & Pick<SubscriptionPlan, 'title'>
  )>, channel?: Maybe<(
    { __typename?: 'Channel' }
    & Pick<Channel, 'title' | 'slug'>
  )>, userPayout?: Maybe<(
    { __typename?: 'UserPayout' }
    & Pick<UserPayout, 'provider' | 'value' | 'currency'>
  )> }
);

export type ConfirmNftPurchaseNotificationMutationVariables = Exact<{
  transactionHash: Scalars['String'];
}>;


export type ConfirmNftPurchaseNotificationMutation = (
  { __typename?: 'Mutation' }
  & { confirmNftPurchase?: Maybe<(
    { __typename?: 'NftNotificationResponse' }
    & { notification?: Maybe<(
      { __typename?: 'Notification' }
      & NotificationFullFragment
    )>, asset?: Maybe<(
      { __typename?: 'NftInfo' }
      & NftInfoFragment
    )> }
  )> }
);

export type ConfirmNftListNotificationMutationVariables = Exact<{
  transactionHash: Scalars['String'];
}>;


export type ConfirmNftListNotificationMutation = (
  { __typename?: 'Mutation' }
  & { confirmNftList?: Maybe<(
    { __typename?: 'NftNotificationResponse' }
    & { notification?: Maybe<(
      { __typename?: 'Notification' }
      & NotificationFullFragment
    )>, asset?: Maybe<(
      { __typename?: 'NftInfo' }
      & NftInfoFragment
    )> }
  )> }
);

export type ConfirmNftCancelListNotificationMutationVariables = Exact<{
  transactionHash: Scalars['String'];
}>;


export type ConfirmNftCancelListNotificationMutation = (
  { __typename?: 'Mutation' }
  & { confirmNftCancelList?: Maybe<(
    { __typename?: 'NftNotificationResponse' }
    & { notification?: Maybe<(
      { __typename?: 'Notification' }
      & NotificationFullFragment
    )>, asset?: Maybe<(
      { __typename?: 'NftInfo' }
      & NftInfoFragment
    )> }
  )> }
);

export type ConfirmNftUpdateListNotificationMutationVariables = Exact<{
  transactionHash: Scalars['String'];
}>;


export type ConfirmNftUpdateListNotificationMutation = (
  { __typename?: 'Mutation' }
  & { confirmNftUpdateList?: Maybe<(
    { __typename?: 'NftNotificationResponse' }
    & { notification?: Maybe<(
      { __typename?: 'Notification' }
      & NotificationFullFragment
    )>, asset?: Maybe<(
      { __typename?: 'NftInfo' }
      & NftInfoFragment
    )> }
  )> }
);

export type NotificationPageQueryVariables = Exact<{
  paging?: Maybe<CursorPagingInput>;
  skipCount?: Maybe<Scalars['Boolean']>;
}>;


export type NotificationPageQuery = (
  { __typename?: 'Query' }
  & { notificationPage: (
    { __typename?: 'NotificationPage' }
    & MakeOptional<Pick<NotificationPage, 'count'>, 'count'>
    & { items: Array<Maybe<(
      { __typename?: 'Notification' }
      & NotificationFullFragment
    )>>, paging: (
      { __typename?: 'CursorPagingInfo' }
      & CursorPagingInfoFragment
    ) }
  ) }
);

export type HasNotificationQueryVariables = Exact<{ [key: string]: never; }>;


export type HasNotificationQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'hasNotification'>
);

export type UpdateNotificationStatusMutationVariables = Exact<{
  input: UpdateNotificationInput;
}>;


export type UpdateNotificationStatusMutation = (
  { __typename?: 'Mutation' }
  & { updateNotificationStatus: (
    { __typename?: 'Notification' }
    & Pick<Notification, '_id' | 'notificationStatus'>
  ) }
);

export type AddUserPaymentMethodStripeMutationVariables = Exact<{
  paymentMethodId: Scalars['String'];
  paymentMethodProvider?: Maybe<PaymentMethodProviderEnum>;
  email?: Maybe<Scalars['String']>;
}>;


export type AddUserPaymentMethodStripeMutation = (
  { __typename?: 'Mutation' }
  & { addUserPaymentMethodStripe: (
    { __typename?: 'UserPaymentMethod' }
    & UserPaymentMethodFragment
  ) }
);

export type RemoveUserPaymentMethodMutationVariables = Exact<{
  _id: Scalars['String'];
}>;


export type RemoveUserPaymentMethodMutation = (
  { __typename?: 'Mutation' }
  & { removeUserPaymentMethod: (
    { __typename?: 'UserPaymentMethod' }
    & UserPaymentMethodFragment
  ) }
);

export type UserPaymentMethodFragment = (
  { __typename?: 'UserPaymentMethod' }
  & Pick<UserPaymentMethod, '_id' | 'refId' | 'userId' | 'provider' | 'paymentMethodStatus'>
  & { paymentMethodDetail: (
    { __typename?: 'PaymentMethodDetail' }
    & { card?: Maybe<(
      { __typename?: 'Card' }
      & CardFragment
    )> }
  ) }
);

export type CardFragment = (
  { __typename?: 'Card' }
  & Pick<Card, 'lastFourDigits' | 'brand' | 'expMonth' | 'expYear'>
);

export type UserPaymentMethodsQueryVariables = Exact<{
  userId: Scalars['String'];
  paymentMethodStatus: Array<PaymentMethodStatusEnum> | PaymentMethodStatusEnum;
  paymentMethodProvider?: Maybe<PaymentMethodProviderEnum>;
}>;


export type UserPaymentMethodsQuery = (
  { __typename?: 'Query' }
  & { userPaymentMethods: Array<Maybe<(
    { __typename?: 'UserPaymentMethod' }
    & UserPaymentMethodFragment
  )>> }
);

export type PostCommonFragment = (
  { __typename?: 'Post' }
  & Pick<Post, '_id' | 'id' | 'slug' | 'title' | 'postStatus' | 'likes' | 'channelId' | 'writerId' | 'isSensitive' | 'postBlurLevel' | 'visibleHeight' | 'subscriptionPlanId' | 'watermarkPosition' | 'createdAt' | 'updatedAt' | 'postType' | 'tokenId' | 'previewContent' | 'isContentLocked' | 'price' | 'currency' | 'publishAt' | 'isPublished'>
  & { tags?: Maybe<Array<Maybe<(
    { __typename?: 'Tag' }
    & Pick<Tag, 'value' | 'label' | 'bgImage'>
  )>>>, asset?: Maybe<(
    { __typename?: 'NftInfo' }
    & NftInfoFragment
  )> }
);

export type PostFullFragment = (
  { __typename?: 'Post' }
  & Pick<Post, 'videoUri'>
  & { content?: Maybe<(
    { __typename?: 'RichTextContent' }
    & Pick<RichTextContent, 'stringifyed' | 'serialized'>
  )>, images?: Maybe<Array<Maybe<(
    { __typename?: 'UploadShort' }
    & Pick<UploadShort, 'uploadType' | 'filepath'>
    & UploadWithIntrinsicSizeFragment
  )>>> }
  & PostCommonFragment
);

export type PostPagePostFragment = (
  { __typename?: 'Post' }
  & Pick<Post, 'commentCount'>
  & { previewImage?: Maybe<(
    { __typename?: 'UploadShort' }
    & UploadWithIntrinsicSizeFragment
  )>, writer: (
    { __typename?: 'User' }
    & UserBasicInfoFragment
  ), content?: Maybe<(
    { __typename?: 'RichTextContent' }
    & Pick<RichTextContent, 'serialized'>
  )>, channel?: Maybe<(
    { __typename?: 'Channel' }
    & ChannelFragment
  )>, subscriptionPlan?: Maybe<(
    { __typename?: 'SubscriptionPlan' }
    & Pick<SubscriptionPlan, '_id' | 'benefits' | 'currentUserSubscriptionStatus' | 'title' | 'slug' | 'subscriptionPlanStatus'>
  )> }
  & PostCommonFragment
);

export type PostDetailFragment = (
  { __typename?: 'Post' }
  & Pick<Post, 'hasCurrentUserReport' | 'isUserContentLocked' | 'userBlurLevel' | 'views' | 'commentCount' | 'isContentLocked' | 'videoUri'>
  & { previewImage?: Maybe<(
    { __typename?: 'UploadShort' }
    & UploadWithIntrinsicSizeFragment
  )>, writer: (
    { __typename?: 'User' }
    & UserBasicInfoFragment
  ), content?: Maybe<(
    { __typename?: 'RichTextContent' }
    & Pick<RichTextContent, 'serialized'>
  )>, channel?: Maybe<(
    { __typename?: 'Channel' }
    & ChannelFragment
  )>, images?: Maybe<Array<Maybe<(
    { __typename?: 'UploadShort' }
    & UploadWithIntrinsicSizeFragment
  )>>> }
  & PostCommonFragment
);

export type PostInfoWithLoggedInUserFragment = (
  { __typename?: 'Post' }
  & Pick<Post, '_id' | 'hasCurrentUserReport' | 'hasCurrentUserLike' | 'userBlurLevel' | 'isUserContentLocked' | 'ownerBlurImageUrl' | 'videoUri' | 'publishAt' | 'isPublished'>
  & { images?: Maybe<Array<Maybe<(
    { __typename?: 'UploadShort' }
    & UploadWithIntrinsicSizeFragment
  )>>>, asset?: Maybe<(
    { __typename?: 'NftInfo' }
    & NftInfoFragment
  )> }
);

export type NftInfoFragment = (
  { __typename?: 'NftInfo' }
  & Pick<NftInfo, 'id' | 'owner' | 'initialOwner' | 'price' | 'listStatus' | 'cid'>
);

export type PublishPostMutationVariables = Exact<{
  slug: Scalars['String'];
}>;


export type PublishPostMutation = (
  { __typename?: 'Mutation' }
  & { publishPost?: Maybe<(
    { __typename?: 'Post' }
    & Pick<Post, '_id' | 'postStatus'>
  )> }
);

export type CreatePostMutationVariables = Exact<{
  postType?: Maybe<PostTypeEnum>;
  signedUrlCount?: Maybe<Scalars['Int']>;
  isOriginalImage?: Maybe<Scalars['Boolean']>;
}>;


export type CreatePostMutation = (
  { __typename?: 'Mutation' }
  & { createPost: (
    { __typename?: 'Post' }
    & PostFullFragment
  ) }
);

export type ReportPostMutationVariables = Exact<{
  input: ReportPostInput;
}>;


export type ReportPostMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'reportPost'>
);

export type UpdatePostMutationVariables = Exact<{
  input: UpdatePostInput;
}>;


export type UpdatePostMutation = (
  { __typename?: 'Mutation' }
  & { updatePost?: Maybe<(
    { __typename?: 'Post' }
    & Pick<Post, '_id' | 'slug' | 'cid'>
  )> }
);

export type RemovePostMutationVariables = Exact<{
  slug: Scalars['String'];
}>;


export type RemovePostMutation = (
  { __typename?: 'Mutation' }
  & { removePost?: Maybe<(
    { __typename?: 'Post' }
    & Pick<Post, '_id' | 'postStatus'>
  )> }
);

export type PostPageQueryVariables = Exact<{
  input?: Maybe<PostPageInput>;
  paging?: Maybe<CursorPagingInput>;
  avatarSize?: Maybe<ImageSizeInput>;
}>;


export type PostPageQuery = (
  { __typename?: 'Query' }
  & { postPage: (
    { __typename?: 'PostPage' }
    & { items: Array<Maybe<(
      { __typename?: 'Post' }
      & PostPagePostFragment
    )>>, paging: (
      { __typename?: 'CursorPagingInfo' }
      & CursorPagingInfoFragment
    ) }
  ) }
);

export type PostInfoWithLoggedInUserQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type PostInfoWithLoggedInUserQuery = (
  { __typename?: 'Query' }
  & { post?: Maybe<(
    { __typename?: 'Post' }
    & PostInfoWithLoggedInUserFragment
  )> }
);

export type PostQueryVariables = Exact<{
  slug: Scalars['String'];
  signedUrlCount?: Maybe<Scalars['Int']>;
  isEdit: Scalars['Boolean'];
  avatarSize?: Maybe<ImageSizeInput>;
  isOriginalImage?: Maybe<Scalars['Boolean']>;
}>;


export type PostQuery = (
  { __typename?: 'Query' }
  & { post?: Maybe<(
    { __typename?: 'Post' }
    & PostDetailFragment
    & PostFullFragment
  )> }
);

export type LikedPostPageQueryVariables = Exact<{
  postTypes: Array<Maybe<PostTypeEnum>> | Maybe<PostTypeEnum>;
  paging?: Maybe<CursorPagingInput>;
  avatarSize?: Maybe<ImageSizeInput>;
}>;


export type LikedPostPageQuery = (
  { __typename?: 'Query' }
  & { likedPostPage?: Maybe<(
    { __typename?: 'LikedPostPage' }
    & { items: Array<Maybe<(
      { __typename?: 'LikedPost' }
      & Pick<LikedPost, '_id' | 'postId' | 'userId'>
      & { post: (
        { __typename?: 'Post' }
        & PostPagePostFragment
      ) }
    )>>, paging: (
      { __typename?: 'CursorPagingInfo' }
      & CursorPagingInfoFragment
    ) }
  )> }
);

export type MapTokensToPostPageQueryVariables = Exact<{
  purchasedOnly: Scalars['Boolean'];
  showSensitiveContent?: Maybe<Scalars['Boolean']>;
  userId: Scalars['String'];
  tokenIds: Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>;
  nextOffset: Scalars['String'];
  hasNext: Scalars['Boolean'];
  avatarSize?: Maybe<ImageSizeInput>;
}>;


export type MapTokensToPostPageQuery = (
  { __typename?: 'Query' }
  & { mapTokensToPostPage?: Maybe<(
    { __typename?: 'MappedPostPage' }
    & { items: Array<Maybe<(
      { __typename?: 'Post' }
      & PostPagePostFragment
    )>>, paging: (
      { __typename?: 'CursorPagingInfo' }
      & CursorPagingInfoFragment
    ) }
  )> }
);

export type Stripe_SubscriptionFragment = (
  { __typename?: 'stripe_subscription' }
  & Pick<Stripe_Subscription, 'id' | 'status'>
  & { latest_invoice: (
    { __typename?: 'stripe_invoice' }
    & { payment_intent?: Maybe<(
      { __typename?: 'stripe_payment_intent' }
      & Pick<Stripe_Payment_Intent, 'client_secret' | 'status'>
    )> }
  ) }
);

export type UserInvoicePageQueryVariables = Exact<{
  userId: Scalars['String'];
  paging?: Maybe<CursorPagingInput>;
  includeWriter?: Maybe<Scalars['Boolean']>;
  includeStringifyed?: Maybe<Scalars['Boolean']>;
  avatarSize?: Maybe<ImageSizeInput>;
}>;


export type UserInvoicePageQuery = (
  { __typename?: 'Query' }
  & { userInvoicePage: (
    { __typename?: 'UserInvoicePage' }
    & { items: Array<Maybe<(
      { __typename?: 'UserInvoice' }
      & UserInvoiceFragment
    )>>, paging: (
      { __typename?: 'CursorPagingInfo' }
      & CursorPagingInfoFragment
    ) }
  ) }
);

export type UserInvoiceFragment = (
  { __typename?: 'UserInvoice' }
  & Pick<UserInvoice, '_id' | 'id' | 'refundedAmount' | 'startAt' | 'endAt' | 'createdAt' | 'type'>
  & { subscriptionPlan?: Maybe<(
    { __typename?: 'SubscriptionPlan' }
    & UserSubscriptionPlanDetailsFragment
  )>, invoice?: Maybe<(
    { __typename?: 'Invoice' }
    & Pick<Invoice, 'url'>
  )> }
);

export type UserSubscriptionPlanFullFragment = (
  { __typename?: 'UserSubscriptionPlan' }
  & Pick<UserSubscriptionPlan, '_id' | 'id' | 'paymentPeriod' | 'userId' | 'subscriptionPlanId' | 'userSubscriptionPlanStatus' | 'userSubscriptionPlanType' | 'startAt' | 'endAt' | 'createdAt' | 'updatedAt' | 'cancelledAt' | 'writerId' | 'latestInvoicesStatus' | 'currentSubscriptionStatus'>
  & { subscriptionPlan: (
    { __typename?: 'SubscriptionPlan' }
    & UserSubscriptionPlanDetailsFragment
  ), user?: Maybe<(
    { __typename?: 'User' }
    & UserBasicInfoFragment
  )>, priceBreakdown?: Maybe<(
    { __typename?: 'priceBreakdown' }
    & Pick<PriceBreakdown, 'price' | 'totalIncome' | 'totalPeriod' | 'providerFee'>
    & { platformFee?: Maybe<Array<Maybe<(
      { __typename?: 'platformfeeBreakDown' }
      & Pick<PlatformfeeBreakDown, 'subscriptionPeriod' | 'writerPlatformFee'>
    )>>> }
  )> }
);

export type UserSubscriptionPlanAfterMutationFragment = (
  { __typename?: 'UserSubscriptionPlan' }
  & Pick<UserSubscriptionPlan, '_id' | 'userSubscriptionPlanStatus'>
  & { subscriptionPlan: (
    { __typename?: 'SubscriptionPlan' }
    & Pick<SubscriptionPlan, 'currentUserSubscriptionStatus'>
  ) }
);

export type SubscribeWithStripeMutationVariables = Exact<{
  subscriptionPlanId: Scalars['String'];
  userPaymentMethodId?: Maybe<Scalars['String']>;
  paymentMethodId?: Maybe<Scalars['String']>;
  paymentMethodProvider?: Maybe<PaymentMethodProviderEnum>;
  email?: Maybe<Scalars['String']>;
}>;


export type SubscribeWithStripeMutation = (
  { __typename?: 'Mutation' }
  & { subscribeWithStripe?: Maybe<(
    { __typename?: 'StripePaymentResponse' }
    & Pick<StripePaymentResponse, 'success' | 'requiresAction' | 'paymentIntentClientSecret'>
  )> }
);

export type PurchaseExpiredContentWithStripeMutationVariables = Exact<{
  subscriptionPlanId: Scalars['String'];
  userPaymentMethodId?: Maybe<Scalars['String']>;
  paymentMethodId?: Maybe<Scalars['String']>;
  postId: Scalars['String'];
  paymentMethodProvider?: Maybe<PaymentMethodProviderEnum>;
  email?: Maybe<Scalars['String']>;
}>;


export type PurchaseExpiredContentWithStripeMutation = (
  { __typename?: 'Mutation' }
  & { purchaseExpiredContentWithStripe: (
    { __typename?: 'StripePaymentResponse' }
    & Pick<StripePaymentResponse, 'success' | 'requiresAction' | 'paymentIntentClientSecret'>
  ) }
);

export type CancelUserSubscriptionPlanMutationVariables = Exact<{
  userSubscriptionPlanId: Scalars['String'];
}>;


export type CancelUserSubscriptionPlanMutation = (
  { __typename?: 'Mutation' }
  & { cancelUserSubscriptionPlan: (
    { __typename?: 'UserSubscriptionPlan' }
    & UserSubscriptionPlanAfterMutationFragment
  ) }
);

export type ReactivateSubscriptionMutationVariables = Exact<{
  userSubscriptionPlanId: Scalars['String'];
}>;


export type ReactivateSubscriptionMutation = (
  { __typename?: 'Mutation' }
  & { reactivateSubscription: (
    { __typename?: 'UserSubscriptionPlan' }
    & UserSubscriptionPlanAfterMutationFragment
  ) }
);

export type SubscriberPageQueryVariables = Exact<{
  input: SubscriberPageInput;
  paging?: Maybe<CursorPagingInput>;
  includeUser: Scalars['Boolean'];
  includeWriter: Scalars['Boolean'];
  avatarSize?: Maybe<ImageSizeInput>;
  includeStringifyed?: Maybe<Scalars['Boolean']>;
}>;


export type SubscriberPageQuery = (
  { __typename?: 'Query' }
  & { subscriberPage: (
    { __typename?: 'UserSubscriptionPage' }
    & { items: Array<Maybe<(
      { __typename?: 'UserSubscriptionPlan' }
      & UserSubscriptionPlanFullFragment
    )>>, paging: (
      { __typename?: 'CursorPagingInfo' }
      & CursorPagingInfoFragment
    ) }
  ) }
);

export type UserSubscriptionPageQueryVariables = Exact<{
  input: UserSubscriptionPageInput;
  paging?: Maybe<CursorPagingInput>;
  includeUser: Scalars['Boolean'];
  includeWriter: Scalars['Boolean'];
  avatarSize?: Maybe<ImageSizeInput>;
  includeStringifyed?: Maybe<Scalars['Boolean']>;
}>;


export type UserSubscriptionPageQuery = (
  { __typename?: 'Query' }
  & { userSubscriptionPage: (
    { __typename?: 'UserSubscriptionPage' }
    & { items: Array<Maybe<(
      { __typename?: 'UserSubscriptionPlan' }
      & UserSubscriptionPlanFullFragment
    )>>, paging: (
      { __typename?: 'CursorPagingInfo' }
      & CursorPagingInfoFragment
    ) }
  ) }
);

export type SubscriptionPlanFullFragment = (
  { __typename?: 'SubscriptionPlan' }
  & Pick<SubscriptionPlan, '_id' | 'id' | 'slug' | 'title' | 'channelIds' | 'price' | 'plan' | 'subscriptionPlanStatus' | 'writerId' | 'createdAt' | 'updatedAt' | 'benefits' | 'currency' | 'currentUserSubscriptionStatus'>
  & { channels?: Maybe<Array<Maybe<(
    { __typename?: 'Channel' }
    & ChannelFragment
  )>>>, image?: Maybe<(
    { __typename?: 'UploadShort' }
    & Pick<UploadShort, 'url'>
  )>, content?: Maybe<(
    { __typename?: 'RichTextContent' }
    & MakeOptional<Pick<RichTextContent, 'serialized' | 'stringifyed'>, 'stringifyed'>
  )> }
);

export type UserSubscriptionPlanDetailsFragment = (
  { __typename?: 'SubscriptionPlan' }
  & { writer?: Maybe<(
    { __typename?: 'User' }
    & UserBasicInfoFragment
  )> }
  & SubscriptionPlanFullFragment
);

export type CreateSubscriptionPlanMutationVariables = Exact<{
  input: CreateSubscriptionPlanInput;
  includeStringifyed?: Maybe<Scalars['Boolean']>;
}>;


export type CreateSubscriptionPlanMutation = (
  { __typename?: 'Mutation' }
  & { createSubscriptionPlan: (
    { __typename?: 'SubscriptionPlan' }
    & SubscriptionPlanFullFragment
  ) }
);

export type RemoveSubscriptionPlanMutationVariables = Exact<{
  input: Scalars['String'];
  includeStringifyed?: Maybe<Scalars['Boolean']>;
  removeAllPosts?: Maybe<Scalars['Boolean']>;
}>;


export type RemoveSubscriptionPlanMutation = (
  { __typename?: 'Mutation' }
  & { removeSubscriptionPlan?: Maybe<(
    { __typename?: 'SubscriptionPlan' }
    & SubscriptionPlanFullFragment
  )> }
);

export type UpdateSubscriptionPlanMutationVariables = Exact<{
  input: UpdateSubscriptionPlanInput;
  includeStringifyed?: Maybe<Scalars['Boolean']>;
}>;


export type UpdateSubscriptionPlanMutation = (
  { __typename?: 'Mutation' }
  & { updateSubscriptionPlan?: Maybe<(
    { __typename?: 'SubscriptionPlan' }
    & SubscriptionPlanFullFragment
  )> }
);

export type SubscriptionPlanPageQueryVariables = Exact<{
  input?: Maybe<SearchInput>;
  includeStringifyed: Scalars['Boolean'];
}>;


export type SubscriptionPlanPageQuery = (
  { __typename?: 'Query' }
  & { subscriptionPlanPage?: Maybe<(
    { __typename?: 'SubscriptionPlanPage' }
    & Pick<SubscriptionPlanPage, 'count'>
    & { items?: Maybe<Array<Maybe<(
      { __typename?: 'SubscriptionPlan' }
      & SubscriptionPlanFullFragment
    )>>> }
  )> }
);

export type TopPostFragment = (
  { __typename?: 'TopPost' }
  & Pick<TopPost, '_id' | 'postId' | 'locale' | 'likes'>
  & { post?: Maybe<(
    { __typename?: 'Post' }
    & PostPagePostFragment
  )> }
);

export type TopPostsQueryVariables = Exact<{
  avatarSize?: Maybe<ImageSizeInput>;
}>;


export type TopPostsQuery = (
  { __typename?: 'Query' }
  & { topPosts: Array<(
    { __typename?: 'TopPost' }
    & TopPostFragment
  )> }
);

export type TopTagFragment = (
  { __typename?: 'TopTag' }
  & Pick<TopTag, '_id' | 'label' | 'value'>
);

export type TopTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type TopTagsQuery = (
  { __typename?: 'Query' }
  & { topTags: Array<(
    { __typename?: 'TopTag' }
    & TopTagFragment
  )> }
);

export type TopWriterFullFragment = (
  { __typename?: 'TopWriter' }
  & Pick<TopWriter, '_id' | 'userId' | 'locale' | 'score'>
  & { user?: Maybe<(
    { __typename?: 'User' }
    & UserBasicInfoFragment
    & UserFollowCountFragment
  )> }
);

export type TopWritersQueryVariables = Exact<{
  avatarSize?: Maybe<ImageSizeInput>;
}>;


export type TopWritersQuery = (
  { __typename?: 'Query' }
  & { topWriters: Array<(
    { __typename?: 'TopWriter' }
    & TopWriterFullFragment
  )> }
);

export type CustomUploadFullFragment = (
  { __typename?: 'CustomUpload' }
  & Pick<CustomUpload, '_id' | 'url' | 'filepath' | 'fileType' | 'uploadType'>
);

export type UploadShortFragment = (
  { __typename?: 'UploadShort' }
  & Pick<UploadShort, '_id' | 'url' | 'uploadType' | 'fileType'>
);

export type UploadWithIntrinsicSizeFragment = (
  { __typename?: 'UploadShort' }
  & Pick<UploadShort, '_id' | 'url' | 'fileType' | 'hasAlpha'>
  & { intrinsicSize?: Maybe<(
    { __typename?: 'IntrinsicSize' }
    & Pick<IntrinsicSize, 'width' | 'height'>
  )> }
);

export type UploadFilesMutationVariables = Exact<{
  input?: Maybe<UploadFileInput>;
}>;


export type UploadFilesMutation = (
  { __typename?: 'Mutation' }
  & { uploadFiles?: Maybe<Array<Maybe<(
    { __typename?: 'CustomUpload' }
    & CustomUploadFullFragment
  )>>> }
);

export type UploadPageQueryVariables = Exact<{
  input: SearchInput;
}>;


export type UploadPageQuery = (
  { __typename?: 'Query' }
  & { uploadPage: (
    { __typename?: 'UploadPage' }
    & Pick<UploadPage, 'count' | 'page' | 'pageSize'>
    & { items: Array<Maybe<(
      { __typename?: 'CustomUpload' }
      & Pick<CustomUpload, '_id' | 'url' | 'fileType' | 'uploadType' | 'uploadStatus' | 'createdAt' | 'updatedAt'>
    )>> }
  ) }
);

export type UserFullFragment = (
  { __typename?: 'User' }
  & Pick<User, '_id' | 'accountName' | 'displayName' | 'birthdate' | 'gender' | 'createdAt' | 'updatedAt' | 'userStatus' | 'locale' | 'showSensitiveContent' | 'shortCaption' | 'walletAccount' | 'userType' | 'creditBalance'>
  & { avatar?: Maybe<(
    { __typename?: 'UploadShort' }
    & UploadShortFragment
  )>, banner?: Maybe<(
    { __typename?: 'UploadShort' }
    & UploadShortFragment
  )>, creatorType: (
    { __typename?: 'CreatorType' }
    & Pick<CreatorType, 'tier' | 'updatedAt'>
  ) }
);

export type UserPostCountFragment = (
  { __typename?: 'User' }
  & Pick<User, 'postCount' | 'currentMonthPostCount'>
);

export type UserSubscribeContentCountFragment = (
  { __typename?: 'User' }
  & Pick<User, 'subscriberCount'>
  & { blurPostCount: (
    { __typename?: 'BlurPostCount' }
    & Pick<BlurPostCount, 'currentMonth' | 'lastMonth' | 'total'>
  ) }
);

export type UserFollowCountFragment = (
  { __typename?: 'User' }
  & Pick<User, 'followingCount' | 'followerCount'>
);

export type UserBasicInfoFragment = (
  { __typename?: 'User' }
  & Pick<User, '_id' | 'accountName' | 'displayName' | 'walletAccount' | 'shortCaption' | 'showSensitiveContent'>
  & { avatar?: Maybe<(
    { __typename?: 'UploadShort' }
    & UploadShortFragment
  )> }
);

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
  avatarSize?: Maybe<ImageSizeInput>;
  bannerSize?: Maybe<ImageSizeInput>;
}>;


export type UpdateUserMutation = (
  { __typename?: 'Mutation' }
  & { updateUser: (
    { __typename?: 'User' }
    & UserFullFragment
  ) }
);

export type UpdateUserCreatorTierMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateUserCreatorTierMutation = (
  { __typename?: 'Mutation' }
  & { updateUserCreatorTier: (
    { __typename?: 'User' }
    & Pick<User, '_id'>
    & { creatorType: (
      { __typename?: 'CreatorType' }
      & Pick<CreatorType, 'tier'>
    ) }
  ) }
);

export type UpdateUserNotificationLastSeenMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateUserNotificationLastSeenMutation = (
  { __typename?: 'Mutation' }
  & { udpateUserNotificationLastSeen: (
    { __typename?: 'User' }
    & Pick<User, 'notificationLastSeen'>
  ) }
);

export type UpdateUserMessageLastSeenMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateUserMessageLastSeenMutation = (
  { __typename?: 'Mutation' }
  & { udpateUserMessageLastSeen: (
    { __typename?: 'User' }
    & Pick<User, 'messageLastSeen'>
  ) }
);

export type LinkWalletAccountMutationVariables = Exact<{
  walletAccount: Scalars['String'];
}>;


export type LinkWalletAccountMutation = (
  { __typename?: 'Mutation' }
  & { linkWalletAccount: (
    { __typename?: 'User' }
    & Pick<User, '_id' | 'walletAccount'>
  ) }
);

export type MeQueryVariables = Exact<{
  avatarSize?: Maybe<ImageSizeInput>;
  bannerSize?: Maybe<ImageSizeInput>;
}>;


export type MeQuery = (
  { __typename?: 'Query' }
  & { me?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'email'>
    & UserFullFragment
  )> }
);

export type UserTypeQueryVariables = Exact<{
  userId?: Maybe<Scalars['String']>;
}>;


export type UserTypeQuery = (
  { __typename?: 'Query' }
  & { user?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, '_id' | 'userType'>
  )> }
);

export type UserBasicInfoQueryVariables = Exact<{
  accountName?: Maybe<Scalars['String']>;
  walletAccount?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  avatarSize?: Maybe<ImageSizeInput>;
}>;


export type UserBasicInfoQuery = (
  { __typename?: 'Query' }
  & { user?: Maybe<(
    { __typename?: 'User' }
    & UserBasicInfoFragment
  )> }
);

export type ProfileUserQueryVariables = Exact<{
  accountName?: Maybe<Scalars['String']>;
  avatarSize?: Maybe<ImageSizeInput>;
  bannerSize?: Maybe<ImageSizeInput>;
}>;


export type ProfileUserQuery = (
  { __typename?: 'Query' }
  & { user?: Maybe<(
    { __typename?: 'User' }
    & { channels: Array<Maybe<(
      { __typename?: 'Channel' }
      & ChannelFragment
    )>> }
    & UserFullFragment
    & UserFollowCountFragment
  )> }
);

export type ProfileUserPostCountQueryVariables = Exact<{
  accountName?: Maybe<Scalars['String']>;
  postTypes?: Maybe<Array<Maybe<PostTypeEnum>> | Maybe<PostTypeEnum>>;
}>;


export type ProfileUserPostCountQuery = (
  { __typename?: 'Query' }
  & { user?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, '_id'>
    & UserPostCountFragment
    & UserSubscribeContentCountFragment
  )> }
);

export type UserAccountNameQueryVariables = Exact<{
  input: Scalars['String'];
}>;


export type UserAccountNameQuery = (
  { __typename?: 'Query' }
  & { userAccountName: (
    { __typename?: 'AccountName' }
    & Pick<AccountName, 'validationStatus' | 'suggestions'>
  ) }
);

export type UserPayoutFragment = (
  { __typename?: 'UserPayout' }
  & Pick<UserPayout, '_id' | 'userId' | 'currency' | 'remarks' | 'receiptUrl' | 'value' | 'userPayoutStatus' | 'provider' | 'createdAt' | 'updatedAt'>
);

export type CreateUserPayoutMutationVariables = Exact<{
  input: CreateUserPayoutInput;
}>;


export type CreateUserPayoutMutation = (
  { __typename?: 'Mutation' }
  & { createUserPayout: (
    { __typename?: 'UserPayout' }
    & UserPayoutFragment
  ) }
);

export type UserPayoutPageQueryVariables = Exact<{
  userId: Scalars['String'];
  paging?: Maybe<CursorPagingInput>;
}>;


export type UserPayoutPageQuery = (
  { __typename?: 'Query' }
  & { userPayoutPage: (
    { __typename?: 'UserPayoutPage' }
    & { items: Array<Maybe<(
      { __typename?: 'UserPayout' }
      & UserPayoutFragment
    )>>, paging: (
      { __typename?: 'CursorPagingInfo' }
      & CursorPagingInfoFragment
    ) }
  ) }
);

export type UserReceivePaymentMethodFragment = (
  { __typename?: 'UserReceivePaymentMethod' }
  & Pick<UserReceivePaymentMethod, '_id' | 'userId' | 'autoTransfer' | 'userReceivePaymentMethodStatus' | 'provider' | 'email' | 'bankAccount' | 'bankAccountHolder' | 'currencyCode' | 'countryCode' | 'bank'>
);

export type UpdateAutoTransferMutationVariables = Exact<{
  receivePaymentMethodId: Scalars['String'];
  autoTransfer: Scalars['Boolean'];
}>;


export type UpdateAutoTransferMutation = (
  { __typename?: 'Mutation' }
  & { updateAutoTransfer: (
    { __typename?: 'UserReceivePaymentMethod' }
    & UserReceivePaymentMethodFragment
  ) }
);

export type CreateUserReceivePaymentMethodMutationVariables = Exact<{
  input: CreateUserReceivePaymentMethodInput;
}>;


export type CreateUserReceivePaymentMethodMutation = (
  { __typename?: 'Mutation' }
  & { createUserReceivePaymentMethod: (
    { __typename?: 'UserReceivePaymentMethod' }
    & UserReceivePaymentMethodFragment
  ) }
);

export type UpdateUserReceivePaymentMethodMutationVariables = Exact<{
  input: UpdateUserReceivePaymentMethodInput;
}>;


export type UpdateUserReceivePaymentMethodMutation = (
  { __typename?: 'Mutation' }
  & { updateUserReceivePaymentMethod: (
    { __typename?: 'UserReceivePaymentMethod' }
    & UserReceivePaymentMethodFragment
  ) }
);

export type UserReceivePaymentMethodsQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type UserReceivePaymentMethodsQuery = (
  { __typename?: 'Query' }
  & { userReceivePaymentMethods: Array<Maybe<(
    { __typename?: 'UserReceivePaymentMethod' }
    & UserReceivePaymentMethodFragment
  )>> }
);

export type EnabledPayoutProvidersQueryVariables = Exact<{ [key: string]: never; }>;


export type EnabledPayoutProvidersQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'enabledPayoutProviders'>
);

export type UserWalletFragment = (
  { __typename?: 'UserWallet' }
  & Pick<UserWallet, '_id' | 'id' | 'income' | 'withdrawal' | 'currency'>
  & { detail?: Maybe<(
    { __typename?: 'UserWalletBalance' }
    & Pick<UserWalletBalance, 'totalBalance' | 'balance' | 'isWithdrewOrProcessing' | 'balanceExcludeProcessingAmount'>
  )> }
);

export type UserWalletQueryVariables = Exact<{
  startAt?: Maybe<Scalars['String']>;
  currency?: Maybe<CurrencyEnum>;
  includeDetail?: Maybe<Scalars['Boolean']>;
}>;


export type UserWalletQuery = (
  { __typename?: 'Query' }
  & { userWallet?: Maybe<(
    { __typename?: 'UserWallet' }
    & UserWalletFragment
  )> }
);



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type LegacyStitchingResolver<TResult, TParent, TContext, TArgs> = {
  fragment: string;
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};

export type NewStitchingResolver<TResult, TParent, TContext, TArgs> = {
  selectionSet: string;
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type StitchingResolver<TResult, TParent, TContext, TArgs> = LegacyStitchingResolver<TResult, TParent, TContext, TArgs> | NewStitchingResolver<TResult, TParent, TContext, TArgs>;
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> =
  | ResolverFn<TResult, TParent, TContext, TArgs>
  | StitchingResolver<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterator<TResult> | Promise<AsyncIterator<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  Query: ResolverTypeWrapper<{}>;
  String: ResolverTypeWrapper<Scalars['String']>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  Int: ResolverTypeWrapper<Scalars['Int']>;
  ID: ResolverTypeWrapper<Scalars['ID']>;
  Mutation: ResolverTypeWrapper<{}>;
  IntCriterionInput: IntCriterionInput;
  StringCriterionInput: StringCriterionInput;
  TimeCriterionInput: TimeCriterionInput;
  SearchCriteriaInput: SearchCriteriaInput;
  SorterTypeEnum: SorterTypeEnum;
  SorterInput: SorterInput;
  PagingInput: PagingInput;
  SearchInput: SearchInput;
  CursorSortingInput: CursorSortingInput;
  CursorPagingInput: CursorPagingInput;
  CursorPagingInfo: ResolverTypeWrapper<CursorPagingInfo>;
  File: ResolverTypeWrapper<File>;
  IntrinsicSize: ResolverTypeWrapper<IntrinsicSize>;
  CustomUpload: ResolverTypeWrapper<CustomUpload>;
  UploadShort: ResolverTypeWrapper<UploadShort>;
  UploadPage: ResolverTypeWrapper<UploadPage>;
  UploadTypeEnum: UploadTypeEnum;
  FileUsageEnum: FileUsageEnum;
  CmsFileUsageEnum: CmsFileUsageEnum;
  FileTypeEnum: FileTypeEnum;
  UploadStatusEnum: UploadStatusEnum;
  UploadFileInput: UploadFileInput;
  IntrinsicSizeInput: IntrinsicSizeInput;
  UploadInput: UploadInput;
  Post: ResolverTypeWrapper<Post>;
  Float: ResolverTypeWrapper<Scalars['Float']>;
  LikedPost: ResolverTypeWrapper<LikedPost>;
  PostPage: ResolverTypeWrapper<PostPage>;
  LikedPostPage: ResolverTypeWrapper<LikedPostPage>;
  MappedPostPage: ResolverTypeWrapper<MappedPostPage>;
  NftInfo: ResolverTypeWrapper<NftInfo>;
  PostStatusEnum: PostStatusEnum;
  WatermarkPositionEnum: WatermarkPositionEnum;
  PostReportStatusEnum: PostReportStatusEnum;
  PostTypeEnum: PostTypeEnum;
  UpdatePostInput: UpdatePostInput;
  ReportPostInput: ReportPostInput;
  PostPageInput: PostPageInput;
  BlurPostCount: ResolverTypeWrapper<BlurPostCount>;
  AccountName: ResolverTypeWrapper<AccountName>;
  CreatorType: ResolverTypeWrapper<CreatorType>;
  User: ResolverTypeWrapper<User>;
  UserPage: ResolverTypeWrapper<UserPage>;
  GenderEnum: GenderEnum;
  LocaleEnum: LocaleEnum;
  UserStatusEnum: UserStatusEnum;
  UserTypeEnum: UserTypeEnum;
  CreatorTypeEnum: CreatorTypeEnum;
  AccountNameValidationStatusEnum: AccountNameValidationStatusEnum;
  LoginMethodEnum: LoginMethodEnum;
  UpdateUserInput: UpdateUserInput;
  UserInput: UserInput;
  UserUploadInput: UserUploadInput;
  TagInput: TagInput;
  Tag: ResolverTypeWrapper<Tag>;
  SubscriptionPlanStatusEnum: SubscriptionPlanStatusEnum;
  CurrentUserSubscriptionStatusEnum: CurrentUserSubscriptionStatusEnum;
  SubscriptionPlanBenefitsEnum: SubscriptionPlanBenefitsEnum;
  SubscriptionPlanPeriodEnum: SubscriptionPlanPeriodEnum;
  UpdateSubscriptionPlanInput: UpdateSubscriptionPlanInput;
  CreateSubscriptionPlanInput: CreateSubscriptionPlanInput;
  SubscriptionPlanStatusHistory: ResolverTypeWrapper<SubscriptionPlanStatusHistory>;
  SubscriptionPlan: ResolverTypeWrapper<SubscriptionPlan>;
  SubscriptionPlanPage: ResolverTypeWrapper<SubscriptionPlanPage>;
  RichTextContent: ResolverTypeWrapper<RichTextContent>;
  UpdateRichTextInput: UpdateRichTextInput;
  Like: ResolverTypeWrapper<Like>;
  LikeInput: LikeInput;
  CurrencyEnum: CurrencyEnum;
  UserSubscriptionPlanStatusEnum: UserSubscriptionPlanStatusEnum;
  UserSubscriptionPlanTypeEnum: UserSubscriptionPlanTypeEnum;
  UserSubscriptionPlanBadgeEnum: UserSubscriptionPlanBadgeEnum;
  SubscriberPageInput: SubscriberPageInput;
  UserSubscriptionPageInput: UserSubscriptionPageInput;
  SubscriberPageForCMSInput: SubscriberPageForCmsInput;
  UserSubscriptionPlan: ResolverTypeWrapper<UserSubscriptionPlan>;
  priceBreakdown: ResolverTypeWrapper<PriceBreakdown>;
  platformfeeBreakDown: ResolverTypeWrapper<PlatformfeeBreakDown>;
  CreateUserSubscriptionPlanResponse: ResolverTypeWrapper<CreateUserSubscriptionPlanResponse>;
  StripePaymentResponse: ResolverTypeWrapper<StripePaymentResponse>;
  UserSubscriptionPlanPage: ResolverTypeWrapper<UserSubscriptionPlanPage>;
  UserSubscriptionPage: ResolverTypeWrapper<UserSubscriptionPage>;
  FollowUser: ResolverTypeWrapper<FollowUser>;
  FollowUserPage: ResolverTypeWrapper<FollowUserPage>;
  FollowTag: ResolverTypeWrapper<FollowTag>;
  FollowTagPage: ResolverTypeWrapper<FollowTagPage>;
  ChannelStatusEnum: ChannelStatusEnum;
  Channel: ResolverTypeWrapper<Channel>;
  UpdateChannelResponse: ResolverTypeWrapper<UpdateChannelResponse>;
  UpdateChannelInput: UpdateChannelInput;
  Notification: ResolverTypeWrapper<Notification>;
  NotificationPage: ResolverTypeWrapper<NotificationPage>;
  NftNotificationResponse: ResolverTypeWrapper<NftNotificationResponse>;
  NotificationTypeEnum: NotificationTypeEnum;
  NotificationStatusEnum: NotificationStatusEnum;
  UpdateNotificationInput: UpdateNotificationInput;
  ConfirmNftPurchaseInput: ConfirmNftPurchaseInput;
  CommentStatusEnum: CommentStatusEnum;
  Comment: ResolverTypeWrapper<Comment>;
  CommentPage: ResolverTypeWrapper<CommentPage>;
  CreateCommentInput: CreateCommentInput;
  CommentPageInput: CommentPageInput;
  FollowChannel: ResolverTypeWrapper<FollowChannel>;
  FollowChannelPage: ResolverTypeWrapper<FollowChannelPage>;
  FollowChannelQueryInput: FollowChannelQueryInput;
  Chat: ResolverTypeWrapper<Chat>;
  InitialChat: ResolverTypeWrapper<InitialChat>;
  ChatPage: ResolverTypeWrapper<ChatPage>;
  MessageStatusEnum: MessageStatusEnum;
  Message: ResolverTypeWrapper<Message>;
  MessagePage: ResolverTypeWrapper<MessagePage>;
  CreateMessageInput: CreateMessageInput;
  UpdateMessageInput: UpdateMessageInput;
  Card: ResolverTypeWrapper<Card>;
  PaymentMethodStatusEnum: PaymentMethodStatusEnum;
  PaymentMethodProviderEnum: PaymentMethodProviderEnum;
  stripe_payment_intent: ResolverTypeWrapper<Stripe_Payment_Intent>;
  stripe_invoice: ResolverTypeWrapper<Stripe_Invoice>;
  stripe_subscription: ResolverTypeWrapper<Stripe_Subscription>;
  PaymentMethodDetail: ResolverTypeWrapper<PaymentMethodDetail>;
  UserPaymentMethod: ResolverTypeWrapper<UserPaymentMethod>;
  Invoice: ResolverTypeWrapper<Invoice>;
  UserInvoice: ResolverTypeWrapper<UserInvoice>;
  UserInvoicePage: ResolverTypeWrapper<UserInvoicePage>;
  UserInvoiceStatusEnum: UserInvoiceStatusEnum;
  UserInvoiceTypeEnum: UserInvoiceTypeEnum;
  TopPost: ResolverTypeWrapper<TopPost>;
  TopTag: ResolverTypeWrapper<TopTag>;
  TopWriter: ResolverTypeWrapper<TopWriter>;
  TopWriterPage: ResolverTypeWrapper<TopWriterPage>;
  UpdatePeriodEnum: UpdatePeriodEnum;
  CacheControlScope: CacheControlScope;
  CreateUserReceivePaymentMethodInput: CreateUserReceivePaymentMethodInput;
  UpdateUserReceivePaymentMethodInput: UpdateUserReceivePaymentMethodInput;
  UserReceivePaymentMethod: ResolverTypeWrapper<UserReceivePaymentMethod>;
  UserReceivePaymentMethodStatusEnum: UserReceivePaymentMethodStatusEnum;
  ReceivePaymentMethodProviderEnum: ReceivePaymentMethodProviderEnum;
  CreateUserPayoutInput: CreateUserPayoutInput;
  UserPayout: ResolverTypeWrapper<UserPayout>;
  UserPayoutPage: ResolverTypeWrapper<UserPayoutPage>;
  UserPayoutStatusEnum: UserPayoutStatusEnum;
  UserPayoutRequestedByEnum: UserPayoutRequestedByEnum;
  PeriodInput: PeriodInput;
  UserWallet: ResolverTypeWrapper<UserWallet>;
  UserWalletBalance: ResolverTypeWrapper<UserWalletBalance>;
  ImageSizeInput: ImageSizeInput;
  FeatureTypeEnum: FeatureTypeEnum;
  FeatureNameEnum: FeatureNameEnum;
  TransactionActionTypeEnum: TransactionActionTypeEnum;
  Application: ResolverTypeWrapper<Application>;
  SubmittedApplicationResponse: ResolverTypeWrapper<SubmittedApplicationResponse>;
  ApplicationTypeEnum: ApplicationTypeEnum;
  ApplicationStatusEnum: ApplicationStatusEnum;
  CreateApplicationInput: CreateApplicationInput;
  UpdateApplicationInput: UpdateApplicationInput;
  UserRefundStatusEnum: UserRefundStatusEnum;
  Upload: ResolverTypeWrapper<Scalars['Upload']>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  Query: {};
  String: Scalars['String'];
  Boolean: Scalars['Boolean'];
  Int: Scalars['Int'];
  ID: Scalars['ID'];
  Mutation: {};
  IntCriterionInput: IntCriterionInput;
  StringCriterionInput: StringCriterionInput;
  TimeCriterionInput: TimeCriterionInput;
  SearchCriteriaInput: SearchCriteriaInput;
  SorterInput: SorterInput;
  PagingInput: PagingInput;
  SearchInput: SearchInput;
  CursorSortingInput: CursorSortingInput;
  CursorPagingInput: CursorPagingInput;
  CursorPagingInfo: CursorPagingInfo;
  File: File;
  IntrinsicSize: IntrinsicSize;
  CustomUpload: CustomUpload;
  UploadShort: UploadShort;
  UploadPage: UploadPage;
  UploadFileInput: UploadFileInput;
  IntrinsicSizeInput: IntrinsicSizeInput;
  UploadInput: UploadInput;
  Post: Post;
  Float: Scalars['Float'];
  LikedPost: LikedPost;
  PostPage: PostPage;
  LikedPostPage: LikedPostPage;
  MappedPostPage: MappedPostPage;
  NftInfo: NftInfo;
  UpdatePostInput: UpdatePostInput;
  ReportPostInput: ReportPostInput;
  PostPageInput: PostPageInput;
  BlurPostCount: BlurPostCount;
  AccountName: AccountName;
  CreatorType: CreatorType;
  User: User;
  UserPage: UserPage;
  UpdateUserInput: UpdateUserInput;
  UserInput: UserInput;
  UserUploadInput: UserUploadInput;
  TagInput: TagInput;
  Tag: Tag;
  UpdateSubscriptionPlanInput: UpdateSubscriptionPlanInput;
  CreateSubscriptionPlanInput: CreateSubscriptionPlanInput;
  SubscriptionPlanStatusHistory: SubscriptionPlanStatusHistory;
  SubscriptionPlan: SubscriptionPlan;
  SubscriptionPlanPage: SubscriptionPlanPage;
  RichTextContent: RichTextContent;
  UpdateRichTextInput: UpdateRichTextInput;
  Like: Like;
  LikeInput: LikeInput;
  SubscriberPageInput: SubscriberPageInput;
  UserSubscriptionPageInput: UserSubscriptionPageInput;
  SubscriberPageForCMSInput: SubscriberPageForCmsInput;
  UserSubscriptionPlan: UserSubscriptionPlan;
  priceBreakdown: PriceBreakdown;
  platformfeeBreakDown: PlatformfeeBreakDown;
  CreateUserSubscriptionPlanResponse: CreateUserSubscriptionPlanResponse;
  StripePaymentResponse: StripePaymentResponse;
  UserSubscriptionPlanPage: UserSubscriptionPlanPage;
  UserSubscriptionPage: UserSubscriptionPage;
  FollowUser: FollowUser;
  FollowUserPage: FollowUserPage;
  FollowTag: FollowTag;
  FollowTagPage: FollowTagPage;
  Channel: Channel;
  UpdateChannelResponse: UpdateChannelResponse;
  UpdateChannelInput: UpdateChannelInput;
  Notification: Notification;
  NotificationPage: NotificationPage;
  NftNotificationResponse: NftNotificationResponse;
  UpdateNotificationInput: UpdateNotificationInput;
  ConfirmNftPurchaseInput: ConfirmNftPurchaseInput;
  Comment: Comment;
  CommentPage: CommentPage;
  CreateCommentInput: CreateCommentInput;
  CommentPageInput: CommentPageInput;
  FollowChannel: FollowChannel;
  FollowChannelPage: FollowChannelPage;
  FollowChannelQueryInput: FollowChannelQueryInput;
  Chat: Chat;
  InitialChat: InitialChat;
  ChatPage: ChatPage;
  Message: Message;
  MessagePage: MessagePage;
  CreateMessageInput: CreateMessageInput;
  UpdateMessageInput: UpdateMessageInput;
  Card: Card;
  stripe_payment_intent: Stripe_Payment_Intent;
  stripe_invoice: Stripe_Invoice;
  stripe_subscription: Stripe_Subscription;
  PaymentMethodDetail: PaymentMethodDetail;
  UserPaymentMethod: UserPaymentMethod;
  Invoice: Invoice;
  UserInvoice: UserInvoice;
  UserInvoicePage: UserInvoicePage;
  TopPost: TopPost;
  TopTag: TopTag;
  TopWriter: TopWriter;
  TopWriterPage: TopWriterPage;
  CreateUserReceivePaymentMethodInput: CreateUserReceivePaymentMethodInput;
  UpdateUserReceivePaymentMethodInput: UpdateUserReceivePaymentMethodInput;
  UserReceivePaymentMethod: UserReceivePaymentMethod;
  CreateUserPayoutInput: CreateUserPayoutInput;
  UserPayout: UserPayout;
  UserPayoutPage: UserPayoutPage;
  PeriodInput: PeriodInput;
  UserWallet: UserWallet;
  UserWalletBalance: UserWalletBalance;
  ImageSizeInput: ImageSizeInput;
  Application: Application;
  SubmittedApplicationResponse: SubmittedApplicationResponse;
  CreateApplicationInput: CreateApplicationInput;
  UpdateApplicationInput: UpdateApplicationInput;
  Upload: Scalars['Upload'];
};

export type CacheControlDirectiveArgs = {   maxAge?: Maybe<Scalars['Int']>;
  scope?: Maybe<CacheControlScope>; };

export type CacheControlDirectiveResolver<Result, Parent, ContextType = any, Args = CacheControlDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  _?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  health?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  uploadPage?: Resolver<ResolversTypes['UploadPage'], ParentType, ContextType, RequireFields<QueryUploadPageArgs, 'input'>>;
  post?: Resolver<Maybe<ResolversTypes['Post']>, ParentType, ContextType, RequireFields<QueryPostArgs, 'slug'>>;
  postPage?: Resolver<ResolversTypes['PostPage'], ParentType, ContextType, RequireFields<QueryPostPageArgs, never>>;
  likedPostPage?: Resolver<Maybe<ResolversTypes['LikedPostPage']>, ParentType, ContextType, RequireFields<QueryLikedPostPageArgs, 'postTypes'>>;
  mapTokensToPostPage?: Resolver<Maybe<ResolversTypes['MappedPostPage']>, ParentType, ContextType, RequireFields<QueryMapTokensToPostPageArgs, 'purchasedOnly' | 'userId' | 'tokenIds' | 'nextOffset' | 'hasNext'>>;
  me?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<QueryUserArgs, never>>;
  userPage?: Resolver<ResolversTypes['UserPage'], ParentType, ContextType, RequireFields<QueryUserPageArgs, never>>;
  userAccountName?: Resolver<ResolversTypes['AccountName'], ParentType, ContextType, RequireFields<QueryUserAccountNameArgs, 'accountName'>>;
  isTestUser?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryIsTestUserArgs, 'email'>>;
  tags?: Resolver<Maybe<Array<Maybe<ResolversTypes['Tag']>>>, ParentType, ContextType, RequireFields<QueryTagsArgs, never>>;
  tag?: Resolver<Maybe<ResolversTypes['Tag']>, ParentType, ContextType, RequireFields<QueryTagArgs, 'value'>>;
  subscriptionPlan?: Resolver<Maybe<ResolversTypes['SubscriptionPlan']>, ParentType, ContextType, RequireFields<QuerySubscriptionPlanArgs, 'slug'>>;
  subscriptionPlanPage?: Resolver<Maybe<ResolversTypes['SubscriptionPlanPage']>, ParentType, ContextType, RequireFields<QuerySubscriptionPlanPageArgs, never>>;
  like?: Resolver<Maybe<ResolversTypes['Like']>, ParentType, ContextType, RequireFields<QueryLikeArgs, 'postId'>>;
  userSubscriptionPage?: Resolver<ResolversTypes['UserSubscriptionPage'], ParentType, ContextType, RequireFields<QueryUserSubscriptionPageArgs, 'input'>>;
  subscriberPage?: Resolver<ResolversTypes['UserSubscriptionPage'], ParentType, ContextType, RequireFields<QuerySubscriberPageArgs, 'input'>>;
  subscriberPageForCms?: Resolver<ResolversTypes['UserSubscriptionPage'], ParentType, ContextType, RequireFields<QuerySubscriberPageForCmsArgs, never>>;
  followUserPage?: Resolver<ResolversTypes['FollowUserPage'], ParentType, ContextType, RequireFields<QueryFollowUserPageArgs, never>>;
  followUserDoc?: Resolver<Maybe<ResolversTypes['FollowUser']>, ParentType, ContextType, RequireFields<QueryFollowUserDocArgs, 'writerId'>>;
  followTagPage?: Resolver<ResolversTypes['FollowTagPage'], ParentType, ContextType, RequireFields<QueryFollowTagPageArgs, never>>;
  followTagDoc?: Resolver<Maybe<ResolversTypes['FollowTag']>, ParentType, ContextType, RequireFields<QueryFollowTagDocArgs, 'tagId'>>;
  channels?: Resolver<Maybe<Array<Maybe<ResolversTypes['Channel']>>>, ParentType, ContextType, RequireFields<QueryChannelsArgs, never>>;
  channel?: Resolver<Maybe<ResolversTypes['Channel']>, ParentType, ContextType, RequireFields<QueryChannelArgs, 'slug'>>;
  hasNotification?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  notificationPage?: Resolver<ResolversTypes['NotificationPage'], ParentType, ContextType, RequireFields<QueryNotificationPageArgs, never>>;
  commentPage?: Resolver<Maybe<ResolversTypes['CommentPage']>, ParentType, ContextType, RequireFields<QueryCommentPageArgs, 'input'>>;
  followChannelPage?: Resolver<ResolversTypes['FollowChannelPage'], ParentType, ContextType, RequireFields<QueryFollowChannelPageArgs, 'input'>>;
  followerChannelPage?: Resolver<ResolversTypes['FollowChannelPage'], ParentType, ContextType, RequireFields<QueryFollowerChannelPageArgs, 'input' | 'creatorId'>>;
  followChannelDoc?: Resolver<Maybe<ResolversTypes['FollowChannel']>, ParentType, ContextType, RequireFields<QueryFollowChannelDocArgs, 'channelId'>>;
  chatPage?: Resolver<Maybe<ResolversTypes['ChatPage']>, ParentType, ContextType, RequireFields<QueryChatPageArgs, never>>;
  initialChat?: Resolver<Maybe<ResolversTypes['InitialChat']>, ParentType, ContextType, RequireFields<QueryInitialChatArgs, 'input'>>;
  hasMessage?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  messagePage?: Resolver<Maybe<ResolversTypes['MessagePage']>, ParentType, ContextType, RequireFields<QueryMessagePageArgs, 'input' | 'currentUserId' | 'relatedUserId'>>;
  userPaymentMethods?: Resolver<Array<Maybe<ResolversTypes['UserPaymentMethod']>>, ParentType, ContextType, RequireFields<QueryUserPaymentMethodsArgs, 'userId' | 'paymentMethodStatus'>>;
  userInvoicePage?: Resolver<ResolversTypes['UserInvoicePage'], ParentType, ContextType, RequireFields<QueryUserInvoicePageArgs, 'userId'>>;
  topPosts?: Resolver<Array<ResolversTypes['TopPost']>, ParentType, ContextType>;
  topTags?: Resolver<Array<ResolversTypes['TopTag']>, ParentType, ContextType>;
  topWriters?: Resolver<Array<ResolversTypes['TopWriter']>, ParentType, ContextType>;
  userReceivePaymentMethods?: Resolver<Array<Maybe<ResolversTypes['UserReceivePaymentMethod']>>, ParentType, ContextType, RequireFields<QueryUserReceivePaymentMethodsArgs, 'userId'>>;
  enabledPayoutProviders?: Resolver<Array<Maybe<ResolversTypes['ReceivePaymentMethodProviderEnum']>>, ParentType, ContextType>;
  userPayoutPage?: Resolver<ResolversTypes['UserPayoutPage'], ParentType, ContextType, RequireFields<QueryUserPayoutPageArgs, 'userId'>>;
  userWallet?: Resolver<Maybe<ResolversTypes['UserWallet']>, ParentType, ContextType, RequireFields<QueryUserWalletArgs, never>>;
  enabledFeatures?: Resolver<Maybe<Array<Maybe<ResolversTypes['FeatureNameEnum']>>>, ParentType, ContextType>;
  application?: Resolver<Maybe<ResolversTypes['Application']>, ParentType, ContextType, RequireFields<QueryApplicationArgs, 'type'>>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  _?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uploadFiles?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomUpload']>>>, ParentType, ContextType, RequireFields<MutationUploadFilesArgs, never>>;
  reportPost?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationReportPostArgs, 'input'>>;
  createPost?: Resolver<ResolversTypes['Post'], ParentType, ContextType, RequireFields<MutationCreatePostArgs, never>>;
  updatePost?: Resolver<Maybe<ResolversTypes['Post']>, ParentType, ContextType, RequireFields<MutationUpdatePostArgs, 'input'>>;
  publishPost?: Resolver<Maybe<ResolversTypes['Post']>, ParentType, ContextType, RequireFields<MutationPublishPostArgs, 'slug'>>;
  removePost?: Resolver<Maybe<ResolversTypes['Post']>, ParentType, ContextType, RequireFields<MutationRemovePostArgs, 'slug'>>;
  updateUser?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationUpdateUserArgs, 'input'>>;
  udpateUserNotificationLastSeen?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  udpateUserMessageLastSeen?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  linkWalletAccount?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationLinkWalletAccountArgs, 'walletAccount'>>;
  updateUserCreatorTier?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  createTag?: Resolver<Maybe<ResolversTypes['Tag']>, ParentType, ContextType, RequireFields<MutationCreateTagArgs, 'input'>>;
  createSubscriptionPlan?: Resolver<ResolversTypes['SubscriptionPlan'], ParentType, ContextType, RequireFields<MutationCreateSubscriptionPlanArgs, 'input'>>;
  updateSubscriptionPlan?: Resolver<Maybe<ResolversTypes['SubscriptionPlan']>, ParentType, ContextType, RequireFields<MutationUpdateSubscriptionPlanArgs, 'input'>>;
  removeSubscriptionPlan?: Resolver<Maybe<ResolversTypes['SubscriptionPlan']>, ParentType, ContextType, RequireFields<MutationRemoveSubscriptionPlanArgs, '_id'>>;
  createLike?: Resolver<Maybe<ResolversTypes['Like']>, ParentType, ContextType, RequireFields<MutationCreateLikeArgs, 'postId'>>;
  removeLike?: Resolver<Maybe<ResolversTypes['Like']>, ParentType, ContextType, RequireFields<MutationRemoveLikeArgs, 'postId'>>;
  purchaseExpiredContentWithStripe?: Resolver<ResolversTypes['StripePaymentResponse'], ParentType, ContextType, RequireFields<MutationPurchaseExpiredContentWithStripeArgs, 'subscriptionPlanId' | 'postId'>>;
  subscribeWithStripe?: Resolver<Maybe<ResolversTypes['StripePaymentResponse']>, ParentType, ContextType, RequireFields<MutationSubscribeWithStripeArgs, 'subscriptionPlanId'>>;
  createUserSubscriptionPlanWithExistingPaymentMethod?: Resolver<ResolversTypes['CreateUserSubscriptionPlanResponse'], ParentType, ContextType, RequireFields<MutationCreateUserSubscriptionPlanWithExistingPaymentMethodArgs, 'subscriptionPlanId' | 'userPaymentMethodId'>>;
  createUserSubscriptionPlanWithNewPaymentMethod?: Resolver<ResolversTypes['CreateUserSubscriptionPlanResponse'], ParentType, ContextType, RequireFields<MutationCreateUserSubscriptionPlanWithNewPaymentMethodArgs, 'subscriptionPlanId' | 'paymentMethodId'>>;
  cancelUserSubscriptionPlan?: Resolver<ResolversTypes['UserSubscriptionPlan'], ParentType, ContextType, RequireFields<MutationCancelUserSubscriptionPlanArgs, 'userSubscriptionPlanId'>>;
  reactivateSubscription?: Resolver<ResolversTypes['UserSubscriptionPlan'], ParentType, ContextType, RequireFields<MutationReactivateSubscriptionArgs, 'userSubscriptionPlanId'>>;
  followUser?: Resolver<ResolversTypes['FollowUser'], ParentType, ContextType, RequireFields<MutationFollowUserArgs, 'writerId'>>;
  unfollowUser?: Resolver<ResolversTypes['FollowUser'], ParentType, ContextType, RequireFields<MutationUnfollowUserArgs, 'writerId'>>;
  followTag?: Resolver<ResolversTypes['FollowTag'], ParentType, ContextType, RequireFields<MutationFollowTagArgs, 'tagId'>>;
  unfollowTag?: Resolver<ResolversTypes['FollowTag'], ParentType, ContextType, RequireFields<MutationUnfollowTagArgs, 'tagId'>>;
  createChannel?: Resolver<ResolversTypes['Channel'], ParentType, ContextType, RequireFields<MutationCreateChannelArgs, 'title' | 'isSensitive'>>;
  updateChannel?: Resolver<ResolversTypes['UpdateChannelResponse'], ParentType, ContextType, RequireFields<MutationUpdateChannelArgs, 'input'>>;
  removeChannel?: Resolver<ResolversTypes['Channel'], ParentType, ContextType, RequireFields<MutationRemoveChannelArgs, '_id'>>;
  updateNotificationStatus?: Resolver<ResolversTypes['Notification'], ParentType, ContextType, RequireFields<MutationUpdateNotificationStatusArgs, 'input'>>;
  confirmNftPurchase?: Resolver<Maybe<ResolversTypes['NftNotificationResponse']>, ParentType, ContextType, RequireFields<MutationConfirmNftPurchaseArgs, 'transactionHash'>>;
  confirmNftList?: Resolver<Maybe<ResolversTypes['NftNotificationResponse']>, ParentType, ContextType, RequireFields<MutationConfirmNftListArgs, 'transactionHash'>>;
  confirmNftCancelList?: Resolver<Maybe<ResolversTypes['NftNotificationResponse']>, ParentType, ContextType, RequireFields<MutationConfirmNftCancelListArgs, 'transactionHash'>>;
  confirmNftUpdateList?: Resolver<Maybe<ResolversTypes['NftNotificationResponse']>, ParentType, ContextType, RequireFields<MutationConfirmNftUpdateListArgs, 'transactionHash'>>;
  createComment?: Resolver<ResolversTypes['Comment'], ParentType, ContextType, RequireFields<MutationCreateCommentArgs, 'input'>>;
  removeComment?: Resolver<ResolversTypes['Comment'], ParentType, ContextType, RequireFields<MutationRemoveCommentArgs, 'commentId'>>;
  followChannel?: Resolver<ResolversTypes['FollowChannel'], ParentType, ContextType, RequireFields<MutationFollowChannelArgs, 'channelId'>>;
  unfollowChannel?: Resolver<ResolversTypes['FollowChannel'], ParentType, ContextType, RequireFields<MutationUnfollowChannelArgs, 'channelId'>>;
  createMessage?: Resolver<ResolversTypes['Message'], ParentType, ContextType, RequireFields<MutationCreateMessageArgs, 'input'>>;
  updateMessage?: Resolver<ResolversTypes['Message'], ParentType, ContextType, RequireFields<MutationUpdateMessageArgs, 'input'>>;
  removeMessage?: Resolver<ResolversTypes['Message'], ParentType, ContextType, RequireFields<MutationRemoveMessageArgs, '_id'>>;
  readMessages?: Resolver<Array<Maybe<ResolversTypes['Message']>>, ParentType, ContextType, RequireFields<MutationReadMessagesArgs, 'senderId'>>;
  removeUserPaymentMethod?: Resolver<ResolversTypes['UserPaymentMethod'], ParentType, ContextType, RequireFields<MutationRemoveUserPaymentMethodArgs, '_id'>>;
  addUserPaymentMethodStripe?: Resolver<ResolversTypes['UserPaymentMethod'], ParentType, ContextType, RequireFields<MutationAddUserPaymentMethodStripeArgs, 'paymentMethodId'>>;
  createUserReceivePaymentMethod?: Resolver<ResolversTypes['UserReceivePaymentMethod'], ParentType, ContextType, RequireFields<MutationCreateUserReceivePaymentMethodArgs, 'input'>>;
  updateUserReceivePaymentMethod?: Resolver<ResolversTypes['UserReceivePaymentMethod'], ParentType, ContextType, RequireFields<MutationUpdateUserReceivePaymentMethodArgs, 'input'>>;
  updateAutoTransfer?: Resolver<ResolversTypes['UserReceivePaymentMethod'], ParentType, ContextType, RequireFields<MutationUpdateAutoTransferArgs, 'receivePaymentMethodId' | 'autoTransfer'>>;
  createUserPayout?: Resolver<ResolversTypes['UserPayout'], ParentType, ContextType, RequireFields<MutationCreateUserPayoutArgs, 'input'>>;
  createApplication?: Resolver<ResolversTypes['SubmittedApplicationResponse'], ParentType, ContextType, RequireFields<MutationCreateApplicationArgs, 'input'>>;
  updateApplication?: Resolver<ResolversTypes['SubmittedApplicationResponse'], ParentType, ContextType, RequireFields<MutationUpdateApplicationArgs, 'input'>>;
};

export type CursorPagingInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['CursorPagingInfo'] = ResolversParentTypes['CursorPagingInfo']> = {
  previous?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  next?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasNext?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileResolvers<ContextType = any, ParentType extends ResolversParentTypes['File'] = ResolversParentTypes['File']> = {
  filename?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mimetype?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  encoding?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntrinsicSizeResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntrinsicSize'] = ResolversParentTypes['IntrinsicSize']> = {
  height?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  width?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomUploadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomUpload'] = ResolversParentTypes['CustomUpload']> = {
  _id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filepath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileType?: Resolver<Maybe<ResolversTypes['FileTypeEnum']>, ParentType, ContextType>;
  uploadType?: Resolver<Maybe<ResolversTypes['UploadTypeEnum']>, ParentType, ContextType>;
  uploadStatus?: Resolver<Maybe<ResolversTypes['UploadStatusEnum']>, ParentType, ContextType>;
  writerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadShortResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadShort'] = ResolversParentTypes['UploadShort']> = {
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uploadType?: Resolver<ResolversTypes['UploadTypeEnum'], ParentType, ContextType>;
  fileType?: Resolver<ResolversTypes['FileTypeEnum'], ParentType, ContextType>;
  filepath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasAlpha?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  intrinsicSize?: Resolver<Maybe<ResolversTypes['IntrinsicSize']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadPage'] = ResolversParentTypes['UploadPage']> = {
  items?: Resolver<Array<Maybe<ResolversTypes['CustomUpload']>>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  page?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pageSize?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pageToken?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PostResolvers<ContextType = any, ParentType extends ResolversParentTypes['Post'] = ResolversParentTypes['Post']> = {
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  views?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  likes?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  blur?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userBlurLevel?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userVisibleHeight?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  postBlurLevel?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  visibleHeight?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  postStatus?: Resolver<ResolversTypes['PostStatusEnum'], ParentType, ContextType>;
  writer?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  writerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subscriptionPlanId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  images?: Resolver<Maybe<Array<Maybe<ResolversTypes['UploadShort']>>>, ParentType, ContextType, RequireFields<PostImagesArgs, never>>;
  content?: Resolver<Maybe<ResolversTypes['RichTextContent']>, ParentType, ContextType>;
  tags?: Resolver<Maybe<Array<Maybe<ResolversTypes['Tag']>>>, ParentType, ContextType>;
  previewImage?: Resolver<Maybe<ResolversTypes['UploadShort']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  multipleImages?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  channelId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isSensitive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  channel?: Resolver<Maybe<ResolversTypes['Channel']>, ParentType, ContextType>;
  commentCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  watermarkPosition?: Resolver<Maybe<ResolversTypes['WatermarkPositionEnum']>, ParentType, ContextType>;
  hasCurrentUserReport?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasCurrentUserLike?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  ownerBlurImageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tokenId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postType?: Resolver<ResolversTypes['PostTypeEnum'], ParentType, ContextType>;
  previewContent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isContentLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isUserContentLocked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  subscriptionPlan?: Resolver<Maybe<ResolversTypes['SubscriptionPlan']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['CurrencyEnum']>, ParentType, ContextType>;
  cid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  asset?: Resolver<Maybe<ResolversTypes['NftInfo']>, ParentType, ContextType>;
  videoUri?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  publishAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isPublished?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LikedPostResolvers<ContextType = any, ParentType extends ResolversParentTypes['LikedPost'] = ResolversParentTypes['LikedPost']> = {
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  postId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  post?: Resolver<ResolversTypes['Post'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PostPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['PostPage'] = ResolversParentTypes['PostPage']> = {
  items?: Resolver<Array<Maybe<ResolversTypes['Post']>>, ParentType, ContextType>;
  paging?: Resolver<ResolversTypes['CursorPagingInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LikedPostPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['LikedPostPage'] = ResolversParentTypes['LikedPostPage']> = {
  items?: Resolver<Array<Maybe<ResolversTypes['LikedPost']>>, ParentType, ContextType>;
  paging?: Resolver<ResolversTypes['CursorPagingInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MappedPostPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['MappedPostPage'] = ResolversParentTypes['MappedPostPage']> = {
  items?: Resolver<Array<Maybe<ResolversTypes['Post']>>, ParentType, ContextType>;
  paging?: Resolver<ResolversTypes['CursorPagingInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NftInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['NftInfo'] = ResolversParentTypes['NftInfo']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  owner?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  initialOwner?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  listStatus?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  cid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BlurPostCountResolvers<ContextType = any, ParentType extends ResolversParentTypes['BlurPostCount'] = ResolversParentTypes['BlurPostCount']> = {
  currentMonth?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lastMonth?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountNameResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountName'] = ResolversParentTypes['AccountName']> = {
  validationStatus?: Resolver<ResolversTypes['AccountNameValidationStatusEnum'], ParentType, ContextType>;
  suggestions?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreatorTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreatorType'] = ResolversParentTypes['CreatorType']> = {
  tier?: Resolver<ResolversTypes['CreatorTypeEnum'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = {
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  loginMethod?: Resolver<Maybe<ResolversTypes['LoginMethodEnum']>, ParentType, ContextType>;
  accountName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  birthdate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  avatar?: Resolver<Maybe<ResolversTypes['UploadShort']>, ParentType, ContextType, RequireFields<UserAvatarArgs, never>>;
  banner?: Resolver<Maybe<ResolversTypes['UploadShort']>, ParentType, ContextType, RequireFields<UserBannerArgs, never>>;
  gender?: Resolver<ResolversTypes['GenderEnum'], ParentType, ContextType>;
  about?: Resolver<Maybe<ResolversTypes['RichTextContent']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  showSensitiveContent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  userStatus?: Resolver<ResolversTypes['UserStatusEnum'], ParentType, ContextType>;
  userType?: Resolver<ResolversTypes['UserTypeEnum'], ParentType, ContextType>;
  creatorType?: Resolver<ResolversTypes['CreatorType'], ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['LocaleEnum']>, ParentType, ContextType>;
  blurPostCount?: Resolver<ResolversTypes['BlurPostCount'], ParentType, ContextType>;
  hasCurrentUserFollowed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  shortCaption?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<UserPostCountArgs, never>>;
  currentMonthPostCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<UserCurrentMonthPostCountArgs, never>>;
  followerCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  followingCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  subscriberCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  channels?: Resolver<Array<Maybe<ResolversTypes['Channel']>>, ParentType, ContextType>;
  notificationLastSeen?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  messageLastSeen?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pubnubAuthKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  walletAccount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creditBalance?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserPage'] = ResolversParentTypes['UserPage']> = {
  users?: Resolver<Array<Maybe<ResolversTypes['User']>>, ParentType, ContextType>;
  page?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pageSize?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pageToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TagResolvers<ContextType = any, ParentType extends ResolversParentTypes['Tag'] = ResolversParentTypes['Tag']> = {
  _id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bgImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  hasCurrentUserFollowed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscriptionPlanStatusHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionPlanStatusHistory'] = ResolversParentTypes['SubscriptionPlanStatusHistory']> = {
  action?: Resolver<ResolversTypes['SubscriptionPlanStatusEnum'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscriptionPlanResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionPlan'] = ResolversParentTypes['SubscriptionPlan']> = {
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  channelIds?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['UploadShort']>, ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  plan?: Resolver<Maybe<ResolversTypes['SubscriptionPlanPeriodEnum']>, ParentType, ContextType>;
  subscriptionPlanStatusHistory?: Resolver<Maybe<Array<Maybe<ResolversTypes['SubscriptionPlanStatusHistory']>>>, ParentType, ContextType>;
  subscriptionPlanStatus?: Resolver<ResolversTypes['SubscriptionPlanStatusEnum'], ParentType, ContextType>;
  writerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  content?: Resolver<Maybe<ResolversTypes['RichTextContent']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  benefits?: Resolver<Maybe<Array<Maybe<ResolversTypes['SubscriptionPlanBenefitsEnum']>>>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['CurrencyEnum']>, ParentType, ContextType>;
  currentUserSubscriptionStatus?: Resolver<ResolversTypes['CurrentUserSubscriptionStatusEnum'], ParentType, ContextType>;
  writer?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  channels?: Resolver<Maybe<Array<Maybe<ResolversTypes['Channel']>>>, ParentType, ContextType>;
  posts?: Resolver<Maybe<Array<Maybe<ResolversTypes['Post']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscriptionPlanPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionPlanPage'] = ResolversParentTypes['SubscriptionPlanPage']> = {
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['SubscriptionPlan']>>>, ParentType, ContextType>;
  page?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pageSize?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pageToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RichTextContentResolvers<ContextType = any, ParentType extends ResolversParentTypes['RichTextContent'] = ResolversParentTypes['RichTextContent']> = {
  stringifyed?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serialized?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LikeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Like'] = ResolversParentTypes['Like']> = {
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  postId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserSubscriptionPlanResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserSubscriptionPlan'] = ResolversParentTypes['UserSubscriptionPlan']> = {
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subscriptionPlanId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  writerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentPeriod?: Resolver<ResolversTypes['SubscriptionPlanPeriodEnum'], ParentType, ContextType>;
  userSubscriptionPlanStatus?: Resolver<ResolversTypes['UserSubscriptionPlanStatusEnum'], ParentType, ContextType>;
  userSubscriptionPlanType?: Resolver<ResolversTypes['UserSubscriptionPlanTypeEnum'], ParentType, ContextType>;
  subscriptionPlan?: Resolver<ResolversTypes['SubscriptionPlan'], ParentType, ContextType>;
  startAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cancelledAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  writer?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  latestInvoicesStatus?: Resolver<Maybe<ResolversTypes['UserInvoiceTypeEnum']>, ParentType, ContextType>;
  currentSubscriptionStatus?: Resolver<Maybe<ResolversTypes['UserSubscriptionPlanBadgeEnum']>, ParentType, ContextType>;
  priceBreakdown?: Resolver<Maybe<ResolversTypes['priceBreakdown']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PriceBreakdownResolvers<ContextType = any, ParentType extends ResolversParentTypes['priceBreakdown'] = ResolversParentTypes['priceBreakdown']> = {
  price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalIncome?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  providerFee?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  platformFee?: Resolver<Maybe<Array<Maybe<ResolversTypes['platformfeeBreakDown']>>>, ParentType, ContextType>;
  totalPeriod?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PlatformfeeBreakDownResolvers<ContextType = any, ParentType extends ResolversParentTypes['platformfeeBreakDown'] = ResolversParentTypes['platformfeeBreakDown']> = {
  subscriptionPeriod?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  writerPlatformFee?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateUserSubscriptionPlanResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateUserSubscriptionPlanResponse'] = ResolversParentTypes['CreateUserSubscriptionPlanResponse']> = {
  paymentMethodId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  priceId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subscription?: Resolver<Maybe<ResolversTypes['stripe_subscription']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StripePaymentResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['StripePaymentResponse'] = ResolversParentTypes['StripePaymentResponse']> = {
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  requiresAction?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  paymentIntentClientSecret?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserSubscriptionPlanPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserSubscriptionPlanPage'] = ResolversParentTypes['UserSubscriptionPlanPage']> = {
  items?: Resolver<Array<Maybe<ResolversTypes['UserSubscriptionPlan']>>, ParentType, ContextType>;
  page?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pageSize?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pageToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserSubscriptionPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserSubscriptionPage'] = ResolversParentTypes['UserSubscriptionPage']> = {
  items?: Resolver<Array<Maybe<ResolversTypes['UserSubscriptionPlan']>>, ParentType, ContextType>;
  paging?: Resolver<ResolversTypes['CursorPagingInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FollowUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['FollowUser'] = ResolversParentTypes['FollowUser']> = {
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  writerId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  writer?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FollowUserPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['FollowUserPage'] = ResolversParentTypes['FollowUserPage']> = {
  items?: Resolver<Array<Maybe<ResolversTypes['FollowUser']>>, ParentType, ContextType>;
  paging?: Resolver<ResolversTypes['CursorPagingInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FollowTagResolvers<ContextType = any, ParentType extends ResolversParentTypes['FollowTag'] = ResolversParentTypes['FollowTag']> = {
  tagId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  tag?: Resolver<Maybe<ResolversTypes['Tag']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FollowTagPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['FollowTagPage'] = ResolversParentTypes['FollowTagPage']> = {
  items?: Resolver<Array<Maybe<ResolversTypes['FollowTag']>>, ParentType, ContextType>;
  page?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pageSize?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pageToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChannelResolvers<ContextType = any, ParentType extends ResolversParentTypes['Channel'] = ResolversParentTypes['Channel']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tagIds?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  creatorId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  creator?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  editorIds?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  isSensitive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isCommentRestricted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  channelStatus?: Resolver<ResolversTypes['ChannelStatusEnum'], ParentType, ContextType>;
  postCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<ChannelPostCountArgs, never>>;
  currentMonthPostCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<ChannelCurrentMonthPostCountArgs, never>>;
  followerCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  subscriberCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  subscriptionCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  blurPostCount?: Resolver<ResolversTypes['BlurPostCount'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateChannelResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateChannelResponse'] = ResolversParentTypes['UpdateChannelResponse']> = {
  channel?: Resolver<ResolversTypes['Channel'], ParentType, ContextType>;
  notification?: Resolver<Maybe<ResolversTypes['Notification']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Notification'] = ResolversParentTypes['Notification']> = {
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  relatedUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  relatedUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  postId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  post?: Resolver<Maybe<ResolversTypes['Post']>, ParentType, ContextType>;
  subscriptionPlanId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscriptionPlan?: Resolver<Maybe<ResolversTypes['SubscriptionPlan']>, ParentType, ContextType>;
  userPayoutId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userPayout?: Resolver<Maybe<ResolversTypes['UserPayout']>, ParentType, ContextType>;
  commentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  channelId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  channel?: Resolver<Maybe<ResolversTypes['Channel']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['NotificationTypeEnum'], ParentType, ContextType>;
  notificationStatus?: Resolver<ResolversTypes['NotificationStatusEnum'], ParentType, ContextType>;
  startAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionHash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationPage'] = ResolversParentTypes['NotificationPage']> = {
  items?: Resolver<Array<Maybe<ResolversTypes['Notification']>>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  paging?: Resolver<ResolversTypes['CursorPagingInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NftNotificationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['NftNotificationResponse'] = ResolversParentTypes['NftNotificationResponse']> = {
  notification?: Resolver<Maybe<ResolversTypes['Notification']>, ParentType, ContextType>;
  asset?: Resolver<Maybe<ResolversTypes['NftInfo']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CommentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Comment'] = ResolversParentTypes['Comment']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  parentCommentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postWriterId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  postId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mentionUserIds?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  content?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  commentStatus?: Resolver<ResolversTypes['CommentStatusEnum'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  mentionUsers?: Resolver<Maybe<Array<Maybe<ResolversTypes['User']>>>, ParentType, ContextType>;
  numberOfReplies?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CommentPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['CommentPage'] = ResolversParentTypes['CommentPage']> = {
  items?: Resolver<Array<Maybe<ResolversTypes['Comment']>>, ParentType, ContextType>;
  paging?: Resolver<ResolversTypes['CursorPagingInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FollowChannelResolvers<ContextType = any, ParentType extends ResolversParentTypes['FollowChannel'] = ResolversParentTypes['FollowChannel']> = {
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  channelId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  channel?: Resolver<ResolversTypes['Channel'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FollowChannelPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['FollowChannelPage'] = ResolversParentTypes['FollowChannelPage']> = {
  items?: Resolver<Array<Maybe<ResolversTypes['FollowChannel']>>, ParentType, ContextType>;
  paging?: Resolver<ResolversTypes['CursorPagingInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatResolvers<ContextType = any, ParentType extends ResolversParentTypes['Chat'] = ResolversParentTypes['Chat']> = {
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  userIds?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  lastMessage?: Resolver<Maybe<ResolversTypes['Message']>, ParentType, ContextType>;
  users?: Resolver<Maybe<Array<Maybe<ResolversTypes['User']>>>, ParentType, ContextType>;
  relatedUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InitialChatResolvers<ContextType = any, ParentType extends ResolversParentTypes['InitialChat'] = ResolversParentTypes['InitialChat']> = {
  _id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  relatedUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChatPage'] = ResolversParentTypes['ChatPage']> = {
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['Chat']>>>, ParentType, ContextType>;
  paging?: Resolver<ResolversTypes['CursorPagingInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['Message'] = ResolversParentTypes['Message']> = {
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  chatId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  senderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  receiverId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  files?: Resolver<Maybe<Array<Maybe<ResolversTypes['UploadShort']>>>, ParentType, ContextType>;
  read?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  messageStatus?: Resolver<ResolversTypes['MessageStatusEnum'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sender?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  receiver?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagePageResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagePage'] = ResolversParentTypes['MessagePage']> = {
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['Message']>>>, ParentType, ContextType>;
  paging?: Resolver<ResolversTypes['CursorPagingInfo'], ParentType, ContextType>;
  mergedManually?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardResolvers<ContextType = any, ParentType extends ResolversParentTypes['Card'] = ResolversParentTypes['Card']> = {
  lastFourDigits?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  brand?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expMonth?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  expYear?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Stripe_Payment_IntentResolvers<ContextType = any, ParentType extends ResolversParentTypes['stripe_payment_intent'] = ResolversParentTypes['stripe_payment_intent']> = {
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  client_secret?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Stripe_InvoiceResolvers<ContextType = any, ParentType extends ResolversParentTypes['stripe_invoice'] = ResolversParentTypes['stripe_invoice']> = {
  payment_intent?: Resolver<Maybe<ResolversTypes['stripe_payment_intent']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Stripe_SubscriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['stripe_subscription'] = ResolversParentTypes['stripe_subscription']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  latest_invoice?: Resolver<ResolversTypes['stripe_invoice'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentMethodDetailResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentMethodDetail'] = ResolversParentTypes['PaymentMethodDetail']> = {
  card?: Resolver<Maybe<ResolversTypes['Card']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserPaymentMethodResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserPaymentMethod'] = ResolversParentTypes['UserPaymentMethod']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  refId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  provider?: Resolver<ResolversTypes['PaymentMethodProviderEnum'], ParentType, ContextType>;
  paymentMethodStatus?: Resolver<ResolversTypes['PaymentMethodStatusEnum'], ParentType, ContextType>;
  paymentMethodDetail?: Resolver<ResolversTypes['PaymentMethodDetail'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvoiceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Invoice'] = ResolversParentTypes['Invoice']> = {
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pdf?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserInvoiceResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserInvoice'] = ResolversParentTypes['UserInvoice']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  refId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  invoice?: Resolver<Maybe<ResolversTypes['Invoice']>, ParentType, ContextType>;
  subscriptionPlanId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subscriptionPlan?: Resolver<Maybe<ResolversTypes['SubscriptionPlan']>, ParentType, ContextType>;
  provider?: Resolver<ResolversTypes['PaymentMethodProviderEnum'], ParentType, ContextType>;
  userInvoiceStatus?: Resolver<ResolversTypes['UserInvoiceStatusEnum'], ParentType, ContextType>;
  refundedAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['UserInvoiceTypeEnum']>, ParentType, ContextType>;
  startAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  writerIncome?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  writerPlatformFee?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  writerProviderFee?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserInvoicePageResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserInvoicePage'] = ResolversParentTypes['UserInvoicePage']> = {
  items?: Resolver<Array<Maybe<ResolversTypes['UserInvoice']>>, ParentType, ContextType>;
  paging?: Resolver<ResolversTypes['CursorPagingInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TopPostResolvers<ContextType = any, ParentType extends ResolversParentTypes['TopPost'] = ResolversParentTypes['TopPost']> = {
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  postId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  locale?: Resolver<ResolversTypes['LocaleEnum'], ParentType, ContextType>;
  likes?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  post?: Resolver<Maybe<ResolversTypes['Post']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TopTagResolvers<ContextType = any, ParentType extends ResolversParentTypes['TopTag'] = ResolversParentTypes['TopTag']> = {
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TopWriterResolvers<ContextType = any, ParentType extends ResolversParentTypes['TopWriter'] = ResolversParentTypes['TopWriter']> = {
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  locale?: Resolver<ResolversTypes['LocaleEnum'], ParentType, ContextType>;
  score?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TopWriterPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['TopWriterPage'] = ResolversParentTypes['TopWriterPage']> = {
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['TopWriter']>>>, ParentType, ContextType>;
  page?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pageSize?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pageToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserReceivePaymentMethodResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserReceivePaymentMethod'] = ResolversParentTypes['UserReceivePaymentMethod']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  autoTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  userReceivePaymentMethodStatus?: Resolver<ResolversTypes['UserReceivePaymentMethodStatusEnum'], ParentType, ContextType>;
  provider?: Resolver<ResolversTypes['ReceivePaymentMethodProviderEnum'], ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bankAccount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bankAccountHolder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currencyCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bank?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserPayoutResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserPayout'] = ResolversParentTypes['UserPayout']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['CurrencyEnum'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  userPayoutStatus?: Resolver<ResolversTypes['UserPayoutStatusEnum'], ParentType, ContextType>;
  provider?: Resolver<ResolversTypes['ReceivePaymentMethodProviderEnum'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  remarks?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  receiptUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserPayoutPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserPayoutPage'] = ResolversParentTypes['UserPayoutPage']> = {
  items?: Resolver<Array<Maybe<ResolversTypes['UserPayout']>>, ParentType, ContextType>;
  paging?: Resolver<ResolversTypes['CursorPagingInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserWalletResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserWallet'] = ResolversParentTypes['UserWallet']> = {
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  income?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  withdrawal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['CurrencyEnum'], ParentType, ContextType>;
  openBalance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  startAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  detail?: Resolver<ResolversTypes['UserWalletBalance'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserWalletBalanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserWalletBalance'] = ResolversParentTypes['UserWalletBalance']> = {
  totalBalance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  balance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  isWithdrewOrProcessing?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  balanceExcludeProcessingAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Application'] = ResolversParentTypes['Application']> = {
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  bankAccount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  postalCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  introduction?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  identityDocument?: Resolver<ResolversTypes['UploadShort'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ApplicationStatusEnum'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ApplicationTypeEnum'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubmittedApplicationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubmittedApplicationResponse'] = ResolversParentTypes['SubmittedApplicationResponse']> = {
  application?: Resolver<ResolversTypes['Application'], ParentType, ContextType>;
  notification?: Resolver<Maybe<ResolversTypes['Notification']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface UploadScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Upload'], any> {
  name: 'Upload';
}

export type Resolvers<ContextType = any> = {
  Query?: QueryResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  CursorPagingInfo?: CursorPagingInfoResolvers<ContextType>;
  File?: FileResolvers<ContextType>;
  IntrinsicSize?: IntrinsicSizeResolvers<ContextType>;
  CustomUpload?: CustomUploadResolvers<ContextType>;
  UploadShort?: UploadShortResolvers<ContextType>;
  UploadPage?: UploadPageResolvers<ContextType>;
  Post?: PostResolvers<ContextType>;
  LikedPost?: LikedPostResolvers<ContextType>;
  PostPage?: PostPageResolvers<ContextType>;
  LikedPostPage?: LikedPostPageResolvers<ContextType>;
  MappedPostPage?: MappedPostPageResolvers<ContextType>;
  NftInfo?: NftInfoResolvers<ContextType>;
  BlurPostCount?: BlurPostCountResolvers<ContextType>;
  AccountName?: AccountNameResolvers<ContextType>;
  CreatorType?: CreatorTypeResolvers<ContextType>;
  User?: UserResolvers<ContextType>;
  UserPage?: UserPageResolvers<ContextType>;
  Tag?: TagResolvers<ContextType>;
  SubscriptionPlanStatusHistory?: SubscriptionPlanStatusHistoryResolvers<ContextType>;
  SubscriptionPlan?: SubscriptionPlanResolvers<ContextType>;
  SubscriptionPlanPage?: SubscriptionPlanPageResolvers<ContextType>;
  RichTextContent?: RichTextContentResolvers<ContextType>;
  Like?: LikeResolvers<ContextType>;
  UserSubscriptionPlan?: UserSubscriptionPlanResolvers<ContextType>;
  priceBreakdown?: PriceBreakdownResolvers<ContextType>;
  platformfeeBreakDown?: PlatformfeeBreakDownResolvers<ContextType>;
  CreateUserSubscriptionPlanResponse?: CreateUserSubscriptionPlanResponseResolvers<ContextType>;
  StripePaymentResponse?: StripePaymentResponseResolvers<ContextType>;
  UserSubscriptionPlanPage?: UserSubscriptionPlanPageResolvers<ContextType>;
  UserSubscriptionPage?: UserSubscriptionPageResolvers<ContextType>;
  FollowUser?: FollowUserResolvers<ContextType>;
  FollowUserPage?: FollowUserPageResolvers<ContextType>;
  FollowTag?: FollowTagResolvers<ContextType>;
  FollowTagPage?: FollowTagPageResolvers<ContextType>;
  Channel?: ChannelResolvers<ContextType>;
  UpdateChannelResponse?: UpdateChannelResponseResolvers<ContextType>;
  Notification?: NotificationResolvers<ContextType>;
  NotificationPage?: NotificationPageResolvers<ContextType>;
  NftNotificationResponse?: NftNotificationResponseResolvers<ContextType>;
  Comment?: CommentResolvers<ContextType>;
  CommentPage?: CommentPageResolvers<ContextType>;
  FollowChannel?: FollowChannelResolvers<ContextType>;
  FollowChannelPage?: FollowChannelPageResolvers<ContextType>;
  Chat?: ChatResolvers<ContextType>;
  InitialChat?: InitialChatResolvers<ContextType>;
  ChatPage?: ChatPageResolvers<ContextType>;
  Message?: MessageResolvers<ContextType>;
  MessagePage?: MessagePageResolvers<ContextType>;
  Card?: CardResolvers<ContextType>;
  stripe_payment_intent?: Stripe_Payment_IntentResolvers<ContextType>;
  stripe_invoice?: Stripe_InvoiceResolvers<ContextType>;
  stripe_subscription?: Stripe_SubscriptionResolvers<ContextType>;
  PaymentMethodDetail?: PaymentMethodDetailResolvers<ContextType>;
  UserPaymentMethod?: UserPaymentMethodResolvers<ContextType>;
  Invoice?: InvoiceResolvers<ContextType>;
  UserInvoice?: UserInvoiceResolvers<ContextType>;
  UserInvoicePage?: UserInvoicePageResolvers<ContextType>;
  TopPost?: TopPostResolvers<ContextType>;
  TopTag?: TopTagResolvers<ContextType>;
  TopWriter?: TopWriterResolvers<ContextType>;
  TopWriterPage?: TopWriterPageResolvers<ContextType>;
  UserReceivePaymentMethod?: UserReceivePaymentMethodResolvers<ContextType>;
  UserPayout?: UserPayoutResolvers<ContextType>;
  UserPayoutPage?: UserPayoutPageResolvers<ContextType>;
  UserWallet?: UserWalletResolvers<ContextType>;
  UserWalletBalance?: UserWalletBalanceResolvers<ContextType>;
  Application?: ApplicationResolvers<ContextType>;
  SubmittedApplicationResponse?: SubmittedApplicationResponseResolvers<ContextType>;
  Upload?: GraphQLScalarType;
};


/**
 * @deprecated
 * Use "Resolvers" root object instead. If you wish to get "IResolvers", add "typesPrefix: I" to your config.
 */
export type IResolvers<ContextType = any> = Resolvers<ContextType>;
export type DirectiveResolvers<ContextType = any> = {
  cacheControl?: CacheControlDirectiveResolver<any, any, ContextType>;
};


/**
 * @deprecated
 * Use "DirectiveResolvers" root object instead. If you wish to get "IDirectiveResolvers", add "typesPrefix: I" to your config.
 */
export type IDirectiveResolvers<ContextType = any> = DirectiveResolvers<ContextType>;